import React from 'react';
import { Grid, Avatar, Divider } from '@material-ui/core';
import CustomAppBar from '../../commons/AppBar';
import Ws from '../../providers/Ws';
import FromServer from './FromServer';
import Utils from '../../providers/Utils';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import { timingSafeEqual } from 'crypto';
import BugetAssign from '../../commons/dialogs/BugetAssign';
import InsertUpdateTask from '../../commons/dialogs/InsertUpdateTask';
import AlertNew from '../../commons/dialogs/AlertNew';
import AlertDialog from '../../commons/dialogs/AlertDialog';
import BugetEtapaTaskB from '../../commons/BugetEtapaTaskB';
import BugetEtapaTask from '../../commons/dialogs/BugetEtapaTask';


export default class EconomicDetalii extends SpecificComponent {
    constructor(props) {
        super(props);

        this.insertTaskRef = React.createRef()
        this.state = {
            sortType: 'task',
            sortTypes: ['user', 'task', 'date'],
            proiect: { taskuri: [], utilizatori: [] },
            taskuri: [],
            cheltuieli: [],
            valoareLog: [],
            bugete: [],
            openBuget: false,
            cheltuialaSelectata: {},
            isOpenInsertTask: false,
            objInfoTask: {},
            objEtapaInfo: {},
            openDeleteTask: false,
            strDataStart: this.dictionary.proiecte.etapeProiect.selectDate,
            strDataFinish: this.dictionary.proiecte.etapeProiect.selectDate,
            dtDataStart: new Date(),
            dtDataFinish: new Date(),
            isHiddenCalendarFinish: true,
            isHiddenCalendar: true,
            isOpenAlertPerioadaTask: false,
            etape: [],
            listTaskuri: [],
            isOpenMenuEtape: false,
            useri: [],
            isOpenUtilizator: false,
            listSubTaskuri: [],
            culoriTaskuri: new Utils().culoriTaskuri(),
            listDocumenteTask: [],
            objInfoProiect: [{ titlu: '' }],
            isOpenBuget: false,
            cheltuialaSelectata: { id: null, nume: '', document_token: null, document_nume: null, document_id: null, tip: 'cost_direct' },

            tipuriIntroducere: [{ id: 'individuala', nume: 'Cheltuiala individuala' }, { id: 'defalcata', nume: 'Cheltuiala defalcata' }],
            tipuriIntroducereB: [{ id: 'individuala', nume: 'Buget individual' }, { id: 'defalcata', nume: 'Buget defalcat' }],
            tipIntroducere: 'individuala',
            isOpenBugetB: false,
            docSubcosturi: [],
            subCosturi: [],
            bugetSelectat: { id: null, nume: '', document_token: null, document_nume: null, document_id: null, tip: 'cost_direct' },
            listBugetC: [],
            utilizatoriCuCheltuieli: 0,
            useriAll: [],
            alertView: false
        }
    }



    componentDidMount() {
        this.access()

        this.getProiecte()
    }

    ws = new Ws()

    fs = new FromServer()

    ls = new LocalStorage().GetUserData()

    u = new Utils()


    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.EsteSef === 1 ? false : true })
        }


    }

    getProiecte = async () => {

        const history = this.props.history

        console.log('history :>> ', history);

        // set first entry in history to mirror the last entry
        // history[0] = history[history.length - 1]

        // // remove all but first history entry
        // history.length = 1

        let bugeteLEgatura = await this.ws.customSelect('select * from bugete_legatura_cheltuieli', {
            p1: 1
        })

        console.log('bugeteLEgatura :>> ', bugeteLEgatura);

        let _proiecte = this.ws.customSelect('select * from proiecte where id = @p1 and isnull(sters,0) != 1 order by id desc', {
            p1: this.props.match.params.idproiect
        })



        let _documenteTaskuri = this.ws.customSelect('select d.*, t.titlu as nume_t  from taskuri_documente d left join taskuri t on d.id_task = t.id where t.id_proiect = @p1 and isnull(d.sters,0) !=1 ', {
            p1: this.props.match.params.idproiect
        })


        let _getBugetProiect = this.ws.customSelect('select * from proiecte_bugete where id_proiect = @p1 ', {
            p1: this.props.match.params.idproiect
        })

        let _getBugetEtapa = this.ws.customSelect(`select b.*, p.id as id_proiect from bugete_etape b left join proiecte p
                                on b.id_etapa in (select id from proiecte_etape where id_proiect = @p1 and isnull(inactiv,0) != 1 ) and isnull(b.sters,0) != 1 ` , {
            p1: this.props.match.params.idproiect
        })

        let _getBugetTask = this.ws.customSelect(`select b.*, p.id as id_proiect from bugete_taskuri b left join proiecte p
                                                    on b.id_task in (select id from taskuri where id_proiect = @p1 and isnull(inactiv,0) != 1) and isnull(b.sters,0) != 1 `, {
            p1: this.props.match.params.idproiect
        })

        // let _getBugetTask = this.ws.customSelect('select * from taskuri' , {
        //     p1:0
        // })


        // let _getCostEtapa = this.ws.customSelect(`select b.*, p.id as id_proiect from costuri_etape b left join proiecte p
        //   on b.id_etapa in (select id from proiecte_etape where id_proiect = @p1 and isnull(inactiv,0) != 1 ) and isnull(b.sters,0) != 1 ` , {
        //     p1: this.props.match.params.idproiect
        // })


        let _getCostTask = this.ws.customSelect(`select ct.*, p.id as id_proiect, b.id_buget, isnull(cr.nr_modificari_noi, 0) as nr_modificari_noi from costuri_taskuri as ct
	
        left outer join (
            select id_cost, count(*)
            as nr_modificari_noi from (
                select lg.id_cost, vz.id_cine from costuri_taskuri_log_modificari as lg 
                            left outer join costuri_taskuri_log_modificari_useri_vazut as vz on (lg.id = vz.id_linie_log_modificare and vz.id_cine = @p2)
    
                ) as pv where pv.id_cine is null
                group by pv.id_cost
        ) as cr
        
        ON ct.id  = cr.id_cost
        left join proiecte p
        on ct.id_task in (select id from taskuri where id_proiect = p.id and isnull(inactiv,0) != 1)
        left join bugete_legatura_cheltuieli b
        on ct.id = b.id_cheltuiala
        where ct.id_task in ( select id from taskuri where id_proiect = @p1 and isnull(inactiv,0) != 1) 
        and isnull(ct.sters,0) != 1 and isnull(b.sters,0) != 1`, {
            p1: this.props.match.params.idproiect,
            p2: this.ls['InfoUser']['IdUser']
        })


        let _getCostTaskRows = this.ws.customSelect(`select c.*, b.id_buget from costuri_taskuri_rows c left join bugete_legatura_cheltuieli b
        on c.id = b.id_cheltuiala
    where c.id_cost in (select id from costuri_taskuri where id_task in (select id from taskuri where id_proiect = @p1))  and isnull(c.sters,0) != 1 and isnull(b.sters,0) != 1`, {
            p1: this.props.match.params.idproiect
        })

        let _getBugeteTaskRows = this.ws.customSelect(`select * from bugete_taskuri_rows where id_cost in 
        (select id from bugete_taskuri where id_task in (select id from taskuri where id_proiect = @p1)) and isnull(sters,0) != 1`, {
            p1: this.props.match.params.idproiect
        })

        let documenteCosturi = this.ws.customSelect(`select c.* , ct.id_task, ct.id as id_cost, t.id_proiect from costuri_taskuri_rows_documente c left join
        costuri_taskuri_rows r on c.id_row_cost = r.id left join 
        costuri_taskuri ct on ct.id = r.id_cost left join taskuri t on t.id = ct.id_task where isnull(c.sters, 0 ) != 1 and t.id_proiect = @p1 `, {
            p1: this.props.match.params.idproiect
        })

        let documenteBugete = this.ws.customSelect(`select c.* , ct.id_task,ct.id as id_buget, t.id_proiect from bugete_taskuri_rows_documente c left join 
       bugete_taskuri_rows r on c.id_row_cost = r.id left join
        bugete_taskuri ct on ct.id = r.id_cost left join taskuri t on t.id = ct.id_task  where isnull(c.sters, 0 ) != 1 and t.id_proiect = @p1`, {
            p1: this.props.match.params.idproiect
        })




        let _getEtape = this.fs.getEtape(this.props.match.params.idproiect)

        let _getTaskuri = this.fs.getTaskuriAndTaskuriParent(this.props.match.params.idproiect)

        let _getUtilizatori = this.fs.getUsers(this.props.match.params.idproiect)

        let [proiecte, documenteTaskuri, getBugetTask, getCostTask, getEtape, getTaskuri, getUtilizatori, getCostTaskRows, getBugetTaskRows, getBugetProiect, getBugetEtapa, docCR, docBR ] =
            await Promise.all([_proiecte, _documenteTaskuri, _getBugetTask, _getCostTask, _getEtape, _getTaskuri, _getUtilizatori, _getCostTaskRows, _getBugeteTaskRows, _getBugetProiect, _getBugetEtapa, documenteCosturi, documenteBugete])


        console.log('proiecte :>> ', proiecte);
        console.log('documenteTaskuri :>> ', documenteTaskuri);
        // console.log('getBugetProiect :>> ', getBugetProiect);
        // console.log('getBugetEtapa :>> ', getBugetEtapa);
        console.log('getBugettask :>> ', getBugetTask);
        // console.log('getCostEtapa :>> ', getCostEtapa);
        console.log('getCostTask :>> ', getCostTask);
        console.log('getEtape :>> ', getEtape);
        console.log('getUtilizatori :>> ', getUtilizatori);
        console.log('getTaskuri :>> ', getTaskuri);
        console.log('getCostTaskRows :>> ', getCostTaskRows);
        console.log('getBugetTaskRows :>> ', getBugetTaskRows);

        if (proiecte.Succes &&
            documenteTaskuri.Succes &&
            // getBugetProiect.Succes &&
            // getBugetEtapa.Succes &&
            getBugetTask.Succes &&
            // getCostEtapa.Succes &&
            getCostTask.Succes &&
            getCostTaskRows.Succes &&
            getBugetTaskRows.Succes &&
            docCR.Succes &&
            docBR.Succes &&
            getEtape &&
            getTaskuri &&
            getUtilizatori
        ) {




            let proiecte2 = [...proiecte.Content]

            let docC = [...docCR.Content]
            let docB = [...docBR.Content]




            for (let i = 0, n = proiecte2.length; i < n; i++) {

                let buget = 0



                let cheltuieli = 0


                let taskuriCheltuieli = []


                let costTask = [...getCostTask.Content].filter(cT => cT.id_proiect === proiecte2[i].id)

                let bugetTaskuri = [...getBugetTask.Content]
                bugetTaskuri = bugetTaskuri.filter(bt => bt.id_proiect === proiecte2[i].id)

                let listCostRows = [...getCostTaskRows.Content]
                let listBugetRows = [...getBugetTaskRows.Content]



                for (let i = 0, n = costTask.length; i < n; i++) {
                    let lr = listCostRows.filter(l => l.id_cost === costTask[i]['id'])

                    for (let j = 0, m = lr.length; j < m; j++) {

                        if(costTask[i].tip === 'cost_personal'){
                            let idxAngajat = getUtilizatori.findIndex(a => Number(a.id) === Number(lr[j].denumire))

                            if(idxAngajat !== -1){
                                lr[j].nume_angajat = getUtilizatori[idxAngajat].nume
                            }else{
                                lr[j].nume_angajat = ' '
                            }
                            
                        }

                        // console.log('lr[j] :>> ', lr[j]);


                        let idxBuget = bugetTaskuri.findIndex(b => b.id === lr[j].id_buget)


                        lr[j]['denumire_buget'] = '';


                        if (idxBuget !== -1) {

                            lr[j]['denumire_buget'] = bugetTaskuri[idxBuget]['nume']
                        }

                        if (lr[j].pret && lr[j].cantitate && lr[j].tva) {
                            if (Number(lr[j].tva_inclus) === 1) {
                                // lr[j]['total'] = ((lr[j].pret * lr[j].cantitate)).toFixed(3)
                                lr[j]['total'] = +(Math.round(((lr[j].pret * lr[j].cantitate)) + "e+3") + "e-3");


                            } else {
                                // lr[j]['total'] = ((((lr[j].pret * lr[j].cantitate) * lr[j].tva) / 100) + (lr[j].pret * lr[j].cantitate)).toFixed(3)
                                lr[j]['total'] = +(Math.round(((((lr[j].pret * lr[j].cantitate) * lr[j].tva) / 100) + (lr[j].pret * lr[j].cantitate)) + "e+3") + "e-3");

                            }
                        } else {
                            lr[j]['total'] = 0
                        }
                    }
                    costTask[i]['costuri_rows'] = lr
                    costTask[i]['open'] = false
                }


                for (let i = 0, n = bugetTaskuri.length; i < n; i++) {
                    let lr = listBugetRows.filter(l => l.id_cost === bugetTaskuri[i]['id'])

                    for (let j = 0, m = lr.length; j < m; j++) {

                        if(bugetTaskuri[i].tip === 'cost_personal'){
                            let idxAngajat = getUtilizatori.findIndex(a => Number(a.id) === Number(lr[j].denumire))

                            if(idxAngajat !== -1){
                                lr[j].nume_angajat = getUtilizatori[idxAngajat].nume
                            }else{
                                lr[j].nume_angajat = ' '
                            }
                            
                        }
                        // console.log('lr[j] :>> ', lr[j]);

                        if (lr[j].pret && lr[j].cantitate && lr[j].tva) {
                            if (Number(lr[j].tva_inclus) === 1) {
                                // lr[j]['total'] = ((lr[j].pret * lr[j].cantitate)).toFixed(3)
                                lr[j]['total'] = +(Math.round(((lr[j].pret * lr[j].cantitate)) + "e+3") + "e-3");


                            } else {
                                // lr[j]['total'] = ((((lr[j].pret * lr[j].cantitate) * lr[j].tva) / 100) + (lr[j].pret * lr[j].cantitate)).toFixed(3)
                                lr[j]['total'] = +(Math.round(((((lr[j].pret * lr[j].cantitate) * lr[j].tva) / 100) + (lr[j].pret * lr[j].cantitate)) + "e+3") + "e-3");

                            }
                        } else {
                            lr[j]['total'] = 0
                        }
                    }
                    bugetTaskuri[i]['bugete_rows'] = lr
                    bugetTaskuri[i]['open'] = false
                }

                console.log('costTask :>> ', costTask);
                console.log('bugetTaskuri :>> ', bugetTaskuri);

                for (let i = 0, n = getTaskuri.length; i < n; i++) {

                    let filterCheltuieli = costTask.filter(c => c.id_task === getTaskuri[i].id)




                    taskuriCheltuieli.push(getTaskuri[i])



                }



                for (let i = 0, n = taskuriCheltuieli.length; i < n; i++) {

                    let idxEtapa = getEtape.findIndex(e => e.id === taskuriCheltuieli[i].id_etapa_proiect)

                    taskuriCheltuieli[i]['suma_cheltuieli'] = 0
                    taskuriCheltuieli[i]['suma_buget'] = 0
                    taskuriCheltuieli[i]['profit'] = 0
                    taskuriCheltuieli[i]['linii_buget'] = 0
                    taskuriCheltuieli[i]['linii_cheltuieli'] = 0

                    if (idxEtapa !== -1) {

                        taskuriCheltuieli[i]['nume_etapa'] = getEtape[idxEtapa].denumire
                    }

                    if (taskuriCheltuieli[i].id_task_parent) {
                        let idxTaskParent = getTaskuri.findIndex(t => t.id === taskuriCheltuieli[i].id_task_parent)

                        if (idxTaskParent !== -1) {

                            taskuriCheltuieli[i]['nume_task_parent'] = getTaskuri[i]['titlu']

                        }


                    }


                    let cheltuieliTask = costTask.filter(c => c.id_task === taskuriCheltuieli[i].id)



                    if (cheltuieliTask.length > 0) {

                        for (let j = 0, n = cheltuieliTask.length; j < n; j++) {


                            taskuriCheltuieli[i]['suma_cheltuieli'] += cheltuieliTask[j]['valoare'] || 0
                        }

                    }

                    let bugetTask = bugetTaskuri.filter(b => b.id_task === taskuriCheltuieli[i].id)

                    if (bugetTask.length > 0) {

                        for (let j = 0, n = bugetTask.length; j < n; j++) {

                            taskuriCheltuieli[i]['suma_buget'] += bugetTask[j]['valoare'] || 0

                        }
                    }

                    taskuriCheltuieli[i]['profit'] = taskuriCheltuieli[i]['suma_buget'] - taskuriCheltuieli[i]['suma_cheltuieli']
                    taskuriCheltuieli[i]['linii_buget'] = bugetTask.length
                    taskuriCheltuieli[i]['linii_cheltuieli'] = cheltuieliTask.length

                }


                console.log('taskuriCheltuieli :>> ', taskuriCheltuieli);

                // console.log('getCostEtapa.Content :>> ', getCostEtapa.Content);
                console.log('getCostTaskContent :>> ', getCostTask.Content);

                // let costEtapa = [...getCostEtapa.Content].filter(cE => cE.id_proiect === proiecte2[i].id)


                // for (let cE = 0, n5 = costEtapa.length; cE < n5; cE++) {
                //     console.log('costEtapa[cE] :>> ', costEtapa[cE]);
                //     cheltuieli += costEtapa[cE].valoare + (costEtapa[cE].valoare * costEtapa[cE].tva / 100)
                // }




                for (let cT = 0, n6 = costTask.length; cT < n6; cT++) {

                    console.log('costTask[cT] :>> ', costTask[cT]);

                    cheltuieli += costTask[cT].valoare + (costTask[cT].valoare * costTask[cT].tva / 100)
                }


                // console.log('getBugetProiect :>> ', getBugetProiect);

                // let bugetProiect = [...getBugetProiect.Content].filter(bP => bP.id_proiect === proiecte2[i].id)

                // for (let b = 0, n4 = bugetProiect.length; b < n4; b++) {
                //     buget += bugetProiect[b].valoare
                // }



                console.log('buget 1 lever :>> ', buget);

                // let bugetEtape = [...getBugetEtapa.Content]
                // bugetEtape = bugetEtape.filter(be => be.id_proiect === proiecte2[i].id)

                // for (let e = 0, n2 = bugetEtape.length; e < n2; e++) {

                //     buget += bugetEtape[e].valoare + (bugetEtape[e].valoare * bugetEtape[e].tva / 100)

                // }

                console.log('buget level 2 :>> ', buget);








                for (let t = 0, n3 = bugetTaskuri.length; t < n3; t++) {
                    buget += bugetTaskuri[t].valoare + (bugetTaskuri[t].valoare * bugetTaskuri[t].tva / 100)


                }



                let utilizatori = []


                for (let i = 0, n = getUtilizatori.length; i < n; i++) {

                    let idxTask = taskuriCheltuieli.findIndex(t => t.id_utilizator_responsabil === getUtilizatori[i].id)

                    if (idxTask !== -1) {
                        utilizatori.push(getUtilizatori[i])
                    }

                }


                console.log('cheltuieli :>> ', cheltuieli);

                console.log('taskuriCheltuieli :>> ', taskuriCheltuieli);

                let docTaskuriAll = documenteTaskuri.Content

                for(let i = 0 , n = docC.length ; i < n ; i++ ){
                    docTaskuriAll.push(docC[i])
                }

                for(let i = 0 , n = docB.length ; i < n ; i++ ){
                    docTaskuriAll.push(docB[i])
                }

                console.log('docTaskuriAll :>> ', docTaskuriAll);


                // proiecte2[i]['buget'] = buget.toFixed(3)
                proiecte2[i]['buget'] = +(Math.round(buget + "e+3") + "e-3");
                // proiecte2[i]['cost'] = cheltuieli.toFixed(3)
                proiecte2[i]['cost'] = +(Math.round(cheltuieli + "e+3") + "e-3");
                // proiecte2[i]['profit'] = (buget - cheltuieli).toFixed(3)
                proiecte2[i]['profit'] = +(Math.round((buget - cheltuieli) + "e+3") + "e-3");
                proiecte2[i]['utilizatori'] = utilizatori
                proiecte2[i]['documente_taskuri'] = docTaskuriAll
                proiecte2[i]['documente_costuri'] = docCR.Content
                proiecte2[i]['documente_bugete'] = docBR.Content
                proiecte2[i]['etape'] = getEtape
                proiecte2[i]['taskuri'] = taskuriCheltuieli
                proiecte2[i]['cheltuieli'] = getCostTask.Content
                proiecte2[i]['bugete'] = bugetTaskuri
                proiecte2[i]['costuri_rows'] = getCostTaskRows.Content
                proiecte2[i]['utilizatori_all'] = getUtilizatori



            }

            this.sortCheltuieli(proiecte2, 'user')

            this.sortCheltuieli(proiecte2, 'task')


        }
    }


    sortCheltuieli = (p, v) => {

        console.log('p :>> ', p);

        let users = [...p[0].utilizatori]
        let usersAll = [...p[0]['utilizatori_all']]
        let cheltuieli = [...p[0].cheltuieli]
        let bugete = [...p[0].bugete]
        let taskuri = [...p[0].taskuri]
        let etape = [...p[0].etape]
        let documente = [...p[0].documente_taskuri]
        let costuriRows = [...p[0].costuri_rows]

        console.warn(usersAll)



        for (let i = 0, n = bugete.length; i < n; i++) {

            let idxC = cheltuieli.findIndex(c => c.id_buget === bugete[i].id)

            if (idxC !== -1) {
                bugete[i].id_cheltuiala = cheltuieli[idxC].id
            } else {
                bugete[i].id_cheltuiala = null
            }
        }



        console.warn('bugete :>> ', bugete);
        console.log('documente :>> ', documente);

        let usersIds = [...new Set(users.map(u => u.id))]



        console.log('usersIds :>> ', usersIds);

        let arrToReturn = []


        let utilizatoriCuCheltuieli = 0

        if (v === 'user') {

            console.log('user :>> ');

            for (let i = 0, n = usersIds.length; i < n; i++) {




                let objToInsert = {
                    nume: '',
                    email: '',
                    id: '',
                    // nume_departament: "",
                    poza: "",
                    nr_taskuri: 0,
                    suma_cheltuieli: 0,
                    taskuri: []

                }

                let taskuriUser = taskuri.filter(t => t.id_utilizator_responsabil === usersIds[i])


                objToInsert['nr_taskuri'] = taskuriUser.length





                for (let o = 0, m = taskuriUser.length; o < m; o++) {
                    objToInsert['suma_cheltuieli'] += taskuriUser[o]['suma_cheltuieli']

                    taskuriUser[o]['bugete'] = bugete.filter(b => b.id_task === taskuriUser[o].id)

                    taskuriUser[o]['cheltuieli'] = cheltuieli.filter(c => c.id_task === taskuriUser[o].id)

                    taskuriUser[o]['open'] = false


                    for (let j = 0, v = taskuriUser[o]['bugete'].length; j < v; j++) {



                        let cheltuieliBuget = costuriRows.filter(c => c.id_buget === taskuriUser[o]['bugete'][j].id)

                        console.log('cheltuieliBuget :>> ', cheltuieliBuget);

                        taskuriUser[o]['bugete'][j]['cheltuiala'] = 0

                        taskuriUser[o]['bugete'][j]['profit'] = 0

                        for (let k = 0, l = cheltuieliBuget.length; k < l; k++) {

                            console.log('cheltuieliBuget[k] :>> ', cheltuieliBuget[k]);

                            if (cheltuieliBuget[k].pret && cheltuieliBuget[k].cantitate && cheltuieliBuget[k].tva >= 0) {

                                if (Number(cheltuieliBuget[k].tva_inclus) === 1) {


                                    taskuriUser[o]['bugete'][j]['cheltuiala'] += ((cheltuieliBuget[k].pret * cheltuieliBuget[k].cantitate))

                                } else {


                                    taskuriUser[o]['bugete'][j]['cheltuiala'] += ((((cheltuieliBuget[k].pret * cheltuieliBuget[k].cantitate) * cheltuieliBuget[k].tva) / 100) + (cheltuieliBuget[k].pret * cheltuieliBuget[k].cantitate))
                                }
                            }



                        }

                        // taskuriUser[o]['bugete'][j]['cheltuiala'] = taskuriUser[o]['bugete'][j]['cheltuiala'].toFixed(2)

                        taskuriUser[o]['bugete'][j]['cheltuiala'] = +(Math.round(taskuriUser[o]['bugete'][j]['cheltuiala'] + "e+3") + "e-3");

                        taskuriUser[o]['bugete'][j]['profit'] = taskuriUser[o]['bugete'][j]['valoare'] - taskuriUser[o]['bugete'][j]['cheltuiala']

                        taskuriUser[o]['bugete'][j]['nr_documente'] = documente.filter(d => d.id_buget === taskuriUser[o]['bugete'][j]['id']).length
                    }




                    for (let j = 0, v = taskuriUser[o]['cheltuieli'].length; j < v; j++) {

                        taskuriUser[o]['cheltuieli'][j]['nr_documente'] = documente.filter(d => d.id_cost === taskuriUser[o]['cheltuieli'][j]['id']).length
                    }



                }

                objToInsert['taskuri'] = taskuriUser


                console.log('objToInsert :>> ', objToInsert);



                let idxUser = users.findIndex(u => u.id === usersIds[i])

                if (idxUser !== -1) {
                    objToInsert.nume = users[idxUser].nume
                    objToInsert.id = users[idxUser].id
                    // objToInsert.nume_departament = users[idxUser].nume_departament
                    objToInsert.poza = users[idxUser].poza
                }

                // let tsk = taskuri.filter(t => t.id_utilizator_responsabil === usersIds[i])
                // console.log('tsk :>> ', tsk);

                // console.log('users[i] :>> ', users[i]);
                // for (let j = 0, m = tsk.length; j < m; j++) {


                //     let cheltuieliF = cheltuieli.filter(c => c.id_task === tsk[j].id)
                //     console.log('cheltuieliF :>> ', cheltuieliF);

                //     for (let k = 0, l = cheltuieliF.length; k < l; k++) {

                //         let idxB = bugete.findIndex(b=> b.id_cheltuiala === cheltuieliF[k].id)

                //         if(idxB !== -1){
                //             cheltuieliF[k]['valoare_buget'] = bugete[idxB].valoare
                //             cheltuieliF[k]['profit'] = bugete[idxB].valoare - cheltuieliF[k].valoare
                //         }else{
                //             cheltuieliF[k]['valoare_buget'] = 0
                //             cheltuieliF[k]['profit']= cheltuieliF[k].valoare ?  `-${cheltuieliF[k].valoare}` : null
                //         }


                //         cheltuieliF[k].nume_task = tsk[j].titlu
                //         cheltuieliF[k].edit = false
                //         cheltuieliF[k]['showTag'] = false



                //         let docidx = documente.findIndex(d => d.id_cost === cheltuieliF[k].id)

                //         if (docidx !== -1) {
                //             cheltuieliF[k]['document_token'] = documente[docidx].token
                //             cheltuieliF[k]['document_id'] = documente[docidx].id
                //             cheltuieliF[k]['document_nume'] = documente[docidx].nume
                //         }else{
                //             cheltuieliF[k]['document_token'] = ''
                //             cheltuieliF[k]['document_id'] = ''
                //             cheltuieliF[k]['document_nume'] = ''
                //         }


                //         objToInsert['cheltuieli'].push(cheltuieliF[k])



                //     }
                // }
                arrToReturn.push(objToInsert)
            }

            console.log('arrToReturn :>> ', arrToReturn);


            users = arrToReturn




            for (let i = 0, n = users.length; i < n; i++) {
                let taskuri = users[i].taskuri.filter(t => t.cheltuieli.length > 0).length

                if (taskuri > 0) {
                    utilizatoriCuCheltuieli += 1
                }
            }

        } else {


            for (let j = 0, m = etape.length; j < m; j++) {


                let objEtapaToInsert = etape[j]

                objEtapaToInsert['open'] = false
                objEtapaToInsert['taskuri'] = []
                objEtapaToInsert['valoare_cheltuieli'] = 0
                objEtapaToInsert['valoare_buget'] = 0
                objEtapaToInsert['linii_buget'] = 0
                objEtapaToInsert['linii_cheltuieli'] = 0


                for (let i = 0, n = taskuri.length; i < n; i++) {

                    let objToInsert = taskuri[i]




                    let useriTaskuri = [...users.filter(u => u.id === taskuri[i].id_utilizator_responsabil)]

                    taskuri[i]['nr_doc'] = documente.filter(d => d.id_task === taskuri[i].id).length

                    taskuri[i]['open'] = false




                    for (let o = 0, m = useriTaskuri.length; o < m; o++) {



                        useriTaskuri[o]['bugete'] = bugete.filter(b => b.id_task === taskuri[i].id)

                        useriTaskuri[o]['cheltuieli'] = cheltuieli.filter(c => c.id_task === taskuri[i].id)

                        useriTaskuri[o]['nr_cheltuieli'] = useriTaskuri[o]['cheltuieli'].length

                        useriTaskuri[o]['valoare_cheltuieli'] = 0

                        useriTaskuri[o]['open'] = false





                    }

                    objToInsert['useri'] = useriTaskuri

                    console.log('objToInsert :>> ', objToInsert);

                    if (taskuri[i].id_etapa_proiect === etape[j].id) {
                        objEtapaToInsert['taskuri'].push(objToInsert)
                        objEtapaToInsert['valoare_cheltuieli'] += objToInsert['suma_cheltuieli']
                        objEtapaToInsert['valoare_buget'] += objToInsert['suma_buget']
                        objEtapaToInsert['linii_buget'] += objToInsert['linii_buget']
                        objEtapaToInsert['linii_cheltuieli'] += objToInsert['linii_cheltuieli']
                    }

                }
                arrToReturn.push(objEtapaToInsert)

            }


            utilizatoriCuCheltuieli = this.state.utilizatoriCuCheltuieli

            console.log('arrToReturn :>> ', arrToReturn);

        }

        console.log('arrToReturn :>> ', arrToReturn);
        console.log('p :>> ', p);


        console.log('users :>> ', users);




        this.setState({
            proiect: p[0],
            objInfoProiect: p,
            taskuri: p[0].taskuri,
            listTaskuri: p[0].taskuri,
            etape: p[0].etape,
            cheltuieli: arrToReturn,
            bugete: bugete,
            useri: users,
            useriAll: usersAll,
            sortType: v,
            utilizatoriCuCheltuieli: utilizatoriCuCheltuieli
        })


    }

    buildAppBarButtons = () => {
        let rez = []

        rez.push(<div>
            <span style={{ color: 'black', marginRight: 10 }}>Astazi:{this.dataAzi()} </span>
        </div>)

        return rez
    }


    dataAzi = () => {
        let u = new Utils()

        let dataAzi = u.defaultData()

        if (this.dictionary.date === 'en') {
            return u.dataPrescurtataEng(dataAzi)
        } else {
            return u.dataPrescurtataRomana(dataAzi)
        }
    }


    changeView = (v) => {


        this.sortCheltuieli([this.state.proiect], v)


    }



    showTag = async (ch, e) => {
        // console.log('e :>> ', e);

        let cloneCheltuieli = [...this.state.cheltuieli]

        console.log('cloneCheltuieli :>> ', cloneCheltuieli);

        let idxC = cloneCheltuieli.findIndex(c => c.id === ch.id)

        console.log('idxC :>> ', idxC);

        if (idxC !== -1) {

            let cheltuieli = [...cloneCheltuieli[idxC]['cheltuieli']]

            let idx = cheltuieli.findIndex(et => et.id === e.id)

            if (idx !== -1) {

                // let showTagI = await this.ws.customSelect(`


                // select m.*  from 
                // ( select * from costuri_taskuri_log_modificari where id_cost = @p1 ) as m
                // left outer join 
                // ( select * from costuri_taskuri_log_modificari_useri_vazut where id_cine = @p2 ) v
                // ON   m.id = isnull( v.id_linie_log_modificare , -1 )`,{
                //     p1:cheltuieli[idx]['id'],
                //     p2:this.ls['InfoUser']['IdUser']
                // })

                let logModif = await this.ws.customSelect(`select id_linie_log_modificare from costuri_taskuri_log_modificari_useri_vazut where id_cine = @p2`, {
                    p2: this.ls['InfoUser']['IdUser']
                })

                console.log('logModif :>> ', logModif);

                let showTagI = await this.ws.customSelect('select * from costuri_taskuri_log_modificari where id_cost = @p1 and id not in (select id_linie_log_modificare from costuri_taskuri_log_modificari_useri_vazut where id_cine = @p2 and isnull(id_linie_log_modificare,0) != 0)', {
                    p1: cheltuieli[idx]['id'],
                    p2: this.ls['InfoUser']['IdUser']
                })

                console.log('showTag :>> ', showTagI);

                if (showTagI.Succes) {
                    cheltuieli[idx].show_tag = true

                    console.log('cheltuieli[idx] :>> ', cheltuieli[idx]);

                    cloneCheltuieli['cheltuieli'] = cheltuieli

                    this.setState({
                        cheltuieli: cloneCheltuieli,
                        valoareLog: showTagI.Content
                    })
                }



            }
        }

    }


    hideTag = async (ch, e) => {
        // console.log('e :>> ', e);

        let cloneCheltuieli = [...this.state.cheltuieli]

        console.log('cloneCheltuieli :>> ', cloneCheltuieli);

        let idxC = cloneCheltuieli.findIndex(c => c.id === ch.id)

        if (idxC !== -1) {

            let cheltuieli = [...cloneCheltuieli[idxC]['cheltuieli']]

            let idx = cheltuieli.findIndex(et => et.id === e.id)

            if (idx !== -1) {





                for (let i = 0, n = this.state.valoareLog.length; i < n; i++) {
                    let objToInsert = {
                        id_linie_log_modificare: this.state.valoareLog[i].id,
                        id_cine: this.ls['InfoUser']['IdUser'],
                        cand: this.u.updateSqlNow()
                    }

                    let vazutCheltuial = await this.ws.insert('costuri_taskuri_log_modificari_useri_vazut', objToInsert)
                }




                cheltuieli[idx].show_tag = false

                console.log('cheltuieli[idx] :>> ', cheltuieli[idx]);

                cloneCheltuieli['cheltuieli'] = cheltuieli

                this.setState({ cheltuieli: cloneCheltuieli }, () => {
                    this.getProiecte()
                })



            }
        }
    }



    getLitereAvatar = (tx) => {



        if (tx !== null) {

            return tx.substring(0, 2)
        }
    }

    goToEdit = (c, ch) => {
        let arr = [...this.state.cheltuieli]

        let idxC = arr.findIndex(cc => c.id === cc.id)

        if (idxC !== -1) {
            let cheltuieli = arr[idxC]['cheltuieli']

            let idxCh = cheltuieli.findIndex(chc => chc.id === ch.id)

            if (idxCh !== -1) {

                arr[idxC]['cheltuieli'][idxCh].edit = true

                console.log('object :>> ', arr[idxC]['cheltuieli'][idxCh]);

                this.setState({ cheltuieli: arr })
            }

        }
    }


    changeCheltuiala = (ev, ch, c) => {

        let arr = [...this.state.cheltuieli]

        let idxC = arr.findIndex(cc => cc.id === c.id)

        if (idxC !== -1) {

            let val = ev.target.value
            let n = ev.target.name

            let cheltuieli = arr[idxC]['cheltuieli']

            let idxCh = cheltuieli.findIndex(chc => chc.id === ch.id)

            if (idxCh !== -1) {

                cheltuieli[idxCh][n] = val

                this.setState({ cheltuieli: arr })
            }
        }

    }



    editCheltuiala = async (c, ch) => {
        let arr = [...this.state.cheltuieli]

        let idxC = arr.findIndex(cc => cc.id === c.id)

        console.log('idxC :>> ', idxC);

        if (idxC !== -1) {
            let cheltuieli = arr[idxC]['cheltuieli']

            let idxCh = cheltuieli.findIndex(chc => chc.id === ch.id)
            console.log('idxCh :>> ', idxCh);

            if (idxCh !== -1) {
                let cheltuialaToEdit = cheltuieli[idxCh]

                console.log('cheltuialaToEdit :>> ', cheltuialaToEdit);

                let objToUpdate = {
                    nume: cheltuialaToEdit.nume,
                    valoare: Number(cheltuialaToEdit.valoare),
                    id_task: cheltuialaToEdit.id_task
                }


                let getOldCost = await this.ws.customSelect(`select * from costuri_taskuri where id = @p1`, {
                    p1: cheltuialaToEdit.id
                })

                if (getOldCost.Succes) {
                    let costVechi = getOldCost.Content.length > 0 ? getOldCost.Content[0] : {}

                    console.log('costVechi :>> ', costVechi);

                    let costLog = {
                        id_cost: cheltuialaToEdit.id,
                        id_cine: this.ls['InfoUser']['IdUser'],
                        nume_cine: this.ls['Nume'],
                        cand: this.u.updateSqlNow(),
                        note: ''
                    }


                    if (costVechi['nume'] !== cheltuialaToEdit.nume) {
                        costLog['note'] += ` a modificat Numele acestei cheltuieli din ${costVechi['nume']} in ${cheltuialaToEdit.nume} `
                    }
                    if (costVechi['valoare'] !== cheltuialaToEdit.valoare) {

                        if (costLog['note'].length > 0) {
                            costLog['note'] += `si Valoarea acestei cheltuieli din ${costVechi['valoare']} in ${cheltuialaToEdit.valoare} `
                        } else {
                            costLog['note'] += ` a modificat Valoarea acestei cheltuieli din ${costVechi['valoare']} in ${cheltuialaToEdit.valoare} `
                        }

                    }



                    if (costLog['note'].length > 0) {
                        let insertLog = await this.ws.insert('costuri_taskuri_log_modificari', costLog)

                        if (insertLog.Succes) {
                            let update = await this.ws.update('costuri_taskuri', objToUpdate, { id: cheltuialaToEdit.id })



                            if (update.Succes) {
                                console.log('succesUpdate :>> ');

                                this.getProiecte()




                            }
                            console.log('log inserat cu succes :>> ');
                        }

                    } else {
                        let update = await this.ws.update('costuri_taskuri', objToUpdate, { id: cheltuialaToEdit.id })



                        if (update.Succes) {
                            console.log('succesUpdate :>> ');
                            this.getProiecte()



                        }

                    }


                }


            }
        }
    }


    goToFileCost = (ch, c) => {
        let adresaFisa = new Ws().adresaMedia + `/Taskuri/Docs/${ch.document_token}`

        window.open(adresaFisa)
    }


    addFileCost = (id) => {
        let pi = document.getElementById(id)

        pi.click()
    }

    uploadCostDoc = async (id, ch) => {
        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);

        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);

            // console.log('idTask :>> ', idTask);
            // console.log('this.props.proiectInfo :>> ', this.props.proiectInfo);

            if (ch.document_token) {



                let delDoc = await ws.update('taskuri_documente', { sters: 1 }, { id: ch.document_id })

                if (delDoc.Succes) {
                    let uploadImage = await ws.uploadimage('Upload/DocTask', saveFile, ch.id_task, this.state.proiect.id, 'cost', ch.id);

                    console.log('uploadImage COST :', uploadImage);
                    if (uploadImage.Succes) {
                        this.getProiecte()
                    }
                }



            } else {
                let uploadImage = await ws.uploadimage('Upload/DocTask', saveFile, ch.id_task, this.state.proiect.id, 'cost', ch.id);

                console.log('uploadImage COST :', uploadImage);
                if (uploadImage.Succes) {
                    this.getProiecte()
                }
            }



        }
    }


    selecteazaBuget = async (b) => {
        console.log('b :>> ', b);

        if (b.id_cheltuiala) {


            let getCheltuieliAlocate = await this.ws.customSelect('select * from bugete_legatura_cheltuieli where id_cheltuiala = @p1 and id_buget = @p2 and isnull(sters,0) != 1 ', {
                p1: b.id_cheltuiala,
                p2: b.id
            })

            if (getCheltuieliAlocate.Succes) {
                let cheltuialaActuala = getCheltuieliAlocate.Content[0]


                if (cheltuialaActuala.id_buget === b.id) {
                    let deleteCheltuiala = await this.ws.update('bugete_legatura_cheltuieli', { sters: 1 }, { id_cheltuiala: b.id_cheltuiala, id_buget: b.id })

                    if (deleteCheltuiala.Succes) {
                        this.getProiecte()
                    }
                } else {

                    let deleteCheltuiala = await this.ws.update('bugete_legatura_cheltuieli', { sters: 1 }, { id_cheltuiala: b.id_cheltuiala, id_buget: b.id })

                    if (deleteCheltuiala.Succes) {

                        let alocaBuget = await this.ws.insert('bugete_legatura_cheltuieli', { id_cheltuiala: b.id_cheltuiala, id_buget: b.id })

                        if (alocaBuget.Succes) {
                            this.getProiecte()
                        }

                    }

                }
            }


        } else {
            let alocaBuget = await this.ws.insert('bugete_legatura_cheltuieli', { id_cheltuiala: this.state.cheltuialaSelectata.id, id_buget: b.id })

            if (alocaBuget.Succes) {
                this.getProiecte()
            }
        }


    }


    dropDownTask = (c, t) => {

        let usr = [...this.state.cheltuieli]

        console.log('sortType :>> ', this.state.sortType);


        if (this.state.sortType === 'user') {
            let idxUsr = usr.findIndex(u => u.id === c.id)

            if (idxUsr !== -1) {
                let tsk = usr[idxUsr]['taskuri']

                let idxTsk = tsk.findIndex(ts => ts.id === t.id)

                if (idxTsk !== -1) {
                    tsk[idxTsk]['open'] = !tsk[idxTsk]['open']

                    this.setState({ cheltuieli: usr })
                }
            }
        } else {

            let idxEtapa = usr.findIndex(ts => ts.id === c.id_etapa_proiect)

            console.log('idxEtapa :>> ', idxEtapa);
            console.log('t :>> ', t);
            console.log('c :>> ', c);


            if (idxEtapa !== -1) {
                let idxTsk = usr[idxEtapa]['taskuri'].findIndex(ts => ts.id === c.id)

                console.log('idxTsk :>> ', idxTsk);

                if (idxTsk !== -1) {
                    usr[idxEtapa]['taskuri'][idxTsk]['open'] = !usr[idxEtapa]['taskuri'][idxTsk]['open']
                    console.log('usr :>> ', usr);
                    console.log('taskuri :>> ', usr[idxEtapa]['taskuri'][idxTsk]);

                    this.setState({ cheltuieli: usr })


                }

            }



        }



    }


    dropDownEtapa = (e) => {

        let usr = [...this.state.cheltuieli]

        let idxEtapa = usr.findIndex(ts => ts.id === e.id)

        if (idxEtapa !== -1) {
            usr[idxEtapa]['open'] = !usr[idxEtapa]['open']

            console.log('usr[idxEtapa] :>> ', usr[idxEtapa]);

            this.setState({ cheltuieli: usr })
        }

    }



    dropDownSubBuget = (c, t, b) => {
        let usr = [...this.state.cheltuieli]


        if (this.state.sortType === 'user') {
            let idxUsr = usr.findIndex(u => u.id === c.id)

            if (idxUsr !== -1) {
                let tsk = usr[idxUsr]['taskuri']

                let idxTsk = tsk.findIndex(ts => ts.id === t.id)

                console.log('object :>> ', tsk);


                if (idxTsk !== -1) {

                    console.log('tsk[idxTsk] :>> ', tsk[idxTsk]);

                    let idxB = tsk[idxTsk].bugete.findIndex(bi => bi.id === b.id)

                    if (idxB !== -1) {

                        tsk[idxTsk]['bugete'][idxB]['open'] = !tsk[idxTsk]['bugete'][idxB]['open']

                        this.setState({ cheltuieli: usr })

                    }

                }
            }
        } else {

            console.log('usr :>> ', usr);
            console.log('t :>> ', c);
            console.log('c :>> ', t);


            let idxEtapa = usr.findIndex(ts => ts.id === c.id_etapa_proiect)

            if (idxEtapa !== -1) {

                let idxTsk = usr[idxEtapa]['taskuri'].findIndex(ts => ts.id === c.id)

                console.log('idxTsk :>> ', idxTsk);

                if (idxTsk !== -1) {

                    console.log('tsk[idxTsk] :>> ', usr[idxTsk]);

                    let idxB = usr[idxEtapa]['taskuri'][idxTsk].bugete.findIndex(bi => bi.id === b.id)

                    if (idxB !== -1) {

                        usr[idxEtapa]['taskuri'][idxTsk]['bugete'][idxB]['open'] = !usr[idxEtapa]['taskuri'][idxTsk]['bugete'][idxB]['open']

                        this.setState({ cheltuieli: usr })

                    }

                }

            }



        }
    }


    dropDownSubCheltuiala = (c, t, b) => {
        let usr = [...this.state.cheltuieli]


        console.log('usr :>> ', usr);
        if (this.state.sortType === 'user') {
            let idxUsr = usr.findIndex(u => u.id === c.id)

            if (idxUsr !== -1) {
                let tsk = usr[idxUsr]['taskuri']

                let idxTsk = tsk.findIndex(ts => ts.id === t.id)



                if (idxTsk !== -1) {

                    console.log('tsk[idxTsk] :>> ', tsk[idxTsk]);

                    let idxB = tsk[idxTsk].cheltuieli.findIndex(bi => bi.id === b.id)

                    if (idxB !== -1) {

                        tsk[idxTsk]['cheltuieli'][idxB]['open'] = !tsk[idxTsk]['cheltuieli'][idxB]['open']

                        this.setState({ cheltuieli: usr })

                    }

                }
            }
        } else {


            let idxEtapa = usr.findIndex(ts => ts.id === c.id_etapa_proiect)

            if(idxEtapa !== -1){
                let idxTsk = usr[idxEtapa]['taskuri'].findIndex(ts => ts.id === c.id)

                console.log('idxTsk :>> ', idxTsk);
    
                if (idxTsk !== -1) {
    
                    console.log('tsk[idxTsk] :>> ', usr[idxTsk]);
    
                    let idxB = usr[idxEtapa]['taskuri'][idxTsk].cheltuieli.findIndex(bi => bi.id === b.id)
    
                    if (idxB !== -1) {

 
                        usr[idxEtapa]['taskuri'][idxTsk]['cheltuieli'][idxB]['open'] = !usr[idxEtapa]['taskuri'][idxTsk]['cheltuieli'][idxB]['open']
    
                        this.setState({ cheltuieli: usr })
    
                    }
    
                }

            }

           

        }
    }

    closeTaskDialog = () => {

        if (this.state.strDataStart !== this.dictionary.proiecte.etapeProiect.selectDate && this.state.strDataFinish !== this.dictionary.proiecte.etapeProiect.selectDate) {
            this.setState({
                isOpenInsertTask: false,
                objInfoTask: { statusul: '', titlu: this.dictionary.proiecte.etapeProiect.numeTask, nume: '', cand_ora: '00:00', pana_cand_ora: '00:00', descriere: this.dictionary.proiecte.etapeProiect.descriereTask, color: '' },
                dtDataStart: new Date(),
                dtDataFinish: new Date(),
                strDataStart: this.dictionary.proiecte.etapeProiect.selectDate,
                strDataFinish: this.dictionary.proiecte.etapeProiect.selectDate,
            }, async () => { await this.getProiecte() })
        }
        else {
            this.deleteTask()
        }
    }


    deleteTask = () => {
        let fs = new FromServer();

        let obj = {
            inactiv: 1
        }


        let update = fs.updateTask(obj, this.state.objInfoTask.id)

        if (update) {
            this.setState({ isOpenInsertTask: false, openDeleteTask: false }, () => {

                this.getProiecte()
            })
        }
    }

    taskFinalizat = async (t) => {



        let fs = new FromServer();

        let ut = new Utils()

        let ls = new LocalStorage()

        let obj = {
            statusul: t.statusul !== 'Finalizat' ? 'Finalizat' : 'In Lucru',
            cand_finalizat: ut.defaultData(),
            cine_finalizat: ls.GetUserData().InfoUser.IdUser
        }

        console.log('t :>> ', t);
        console.log('obj :>> ', obj);
        // console.log('this.state.objEta-------s-d-s-d-sd-s-d------dsd-s-sd :', this.state.objEtapaInfo);

        // console.log('titlu :', obj.statusul);


        let dataFinalizare = t.pana_cand_data.split('T')[0]


        if (obj.statusul === 'Finalizat') {
            if (new Date(ut.defaultData()) >= new Date(dataFinalizare)) {
                console.log('openAlert :>> ',);

                this.setState({
                    openAlertIntarziat: true,
                    objInfoTask: t
                })
            } else {
                console.log('finalizeaza :>> ',);

                let update = await fs.updateTask(obj, t.id)

                console.log('update :>> ', update);

                if (update) {

                    let cloneTaskuri = [...this.state.listTaskuri]


                    let idx = cloneTaskuri.findIndex(f => f.id === t.id)
                    console.log('idx :>> ', idx);

                    if (idx !== -1) {

                        cloneTaskuri[idx].statusul = obj.statusul
                    }


                    let getStatus = cloneTaskuri.filter(st => st.statusul !== 'Finalizat')

                    let status = ''

                    if (getStatus.length > 0) {
                        status = 'In Lucru'
                    } else {
                        status = 'Finalizat'
                    }


                    let etapaSts = {
                        statusul: status
                    }


                    // console.log('filterTaskuri :', filterTaskuri);
                    console.log('this.state.objEtapaInfo.id :>> ', this.state.objEtapaSelectata.id);

                    let updateEtapa = await fs.updateEtapa(etapaSts, this.state.objEtapaSelectata.id)



                    if (updateEtapa) {

                        this.getProiecte()
                    }

                }
            }
        } else {
            console.log('finalizeaza :>> ',);

            let update = await fs.updateTask(obj, t.id)

            console.log('update :>> ', update);

            if (update) {

                let cloneTaskuri = [...this.state.listTaskuri]


                let idx = cloneTaskuri.findIndex(f => f.id === t.id)
                console.log('idx :>> ', idx);

                if (idx !== -1) {

                    cloneTaskuri[idx].statusul = obj.statusul
                }


                let getStatus = cloneTaskuri.filter(st => st.statusul !== 'Finalizat')

                let status = ''

                if (getStatus.length > 0) {
                    status = 'In Lucru'
                } else {
                    status = 'Finalizat'
                }


                let etapaSts = {
                    statusul: status
                }


                // console.log('filterTaskuri :', filterTaskuri);
                console.log('this.state.objEtapaInfo.id :>> ', this.state.objEtapaSelectata.id);

                let updateEtapa = await fs.updateEtapa(etapaSts, this.state.objEtapaSelectata.id)



                if (updateEtapa) {

                    this.getProiecte()
                }

            }
        }





    }

    getTaskData = async (t, slide = false) => {
        // console.warn('t :', t);
        // console.warn('e :', e);

        let u = new Utils()

        let el = t
        el.descriere = t.descriere || this.dictionary.proiecte.etapeProiect.descriereTask


        let etape = [...this.state.proiect.etape]

        console.log('etape :>> ', etape);

        let idx = etape.findIndex(et => et.id === t.id_etapa_proiect)

        let e = {}

        if (idx !== -1) {
            e = etape[idx]
        }

        console.warn('el :', el);

        let fs = new FromServer();

        let getTimpiLucru = await fs.getTaskuriTimpiLucru(el.id_utilizator_responsabil, t.id)

        let taskuriDoc = await fs.getDocumenteTask(el.id)


        // console.warn('getTimpiLucru---------------- :', getTimpiLucru);

        if (taskuriDoc.Succes) {
            console.log('taskuriDoc :>> ', taskuriDoc);

            let timpiLucru = getTimpiLucru.Content

            let counter = timpiLucru.length

            for (let i = 0; i < counter; i++) {
                timpiLucru[i].data_introdusa = u.ParseDataFromSql(timpiLucru[i].data_introdusa)
            }
            let doc = taskuriDoc.Content

            let docL = doc.length

            for (let i = 0; i < docL; i++) {
                doc[i].cand_uploadat = u.ParseDataFromSql(doc[i].cand_uploadat)
                doc[i].doc_info = 'Task'
            }





            this.setState({
                isOpenInsertTask: slide === true ? false : true,
                objInfoTask: el,
                strDataStart: t.cand_data !== null ? (this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(t.cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(t.cand_data))) : this.dictionary.proiecte.etapeProiect.selectDate,
                strDataFinish: t.pana_cand_data !== null ? (this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(t.pana_cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(t.pana_cand_data))) : this.dictionary.proiecte.etapeProiect.selectDate,
                dtDataStart: t.cand_data !== null ? new Date(t.cand_data) : new Date(),
                dtDataFinish: t.pana_cand_data !== null ? new Date(t.pana_cand_data) : new Date(),
                listTimpiLucru: timpiLucru,
                objEtapaInfo: e,
                listDocumenteTask: doc
            }, () => {
                this.insertTaskRef.current.openBugetEtapa()
            })
        }




    }

    getPerioada = () => {
        this.setState({
            isHiddenCalendar: this.state.isHiddenCalendar ? false : true,
            isHiddenCalendarFinish: this.state.isHiddenCalendarFinish ? false : true
        })
    }

    hideCal = () => {

        if (this.state.isHiddenCalendar === false) {
            this.setState({ isHiddenCalendar: true })
        }

        if (this.state.isHiddenCalendarFinish === false) {
            this.setState({ isHiddenCalendarFinish: true })
        }


    }

    changeResponsabil = (ev) => {

    }

    dataStartChange = async (ev) => {
        let fs = new FromServer();

        let u = new Utils()

        //  console.warn('ev data start----s-da-s-da-sd-a-d-as :', ev);

        let dataEv = new Date(ev)
        dataEv = new Date(dataEv.setDate(dataEv.getDate() + 1))

        // console.warn('dataEv :', dataEv);
        console.log('this.state.objEtapaInfo :>> ', this.state.objEtapaInfo);

        if (new Date(this.state.objEtapaInfo.durata_de_la) <= dataEv && ev <= new Date(this.state.objEtapaInfo.durata_pana_la)) {


            let obj = {
                cand_data: u.transformDataForSql(ev)
            }




            //    console.log('obj :', obj);


            let update = await fs.updateTask(obj, this.state.objInfoTask.id)

            if (update) {



                this.setState({
                    dtDataStart: ev,
                    strDataStart: this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(obj.cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(obj.cand_data)),
                    isHiddenCalendar: false

                }, () => {
                    this.getProiecte()
                })
                return true
            }
        } else if (new Date(this.state.objEtapaInfo.cand_data) <= ev && ev <= new Date(this.state.objEtapaInfo.pana_cand_data)) {

            // console.log('this.state.objEtapaInfo :>> ', this.state.objEtapaInfo);
            // console.log('dataEv :>> ', dataEv);

            let obj = {
                cand_data: u.transformDataForSql(ev)
            }

            let update = await fs.updateTask(obj, this.state.objInfoTask.id)

            if (update) {



                this.setState({
                    dtDataStart: ev,
                    strDataStart: this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(obj.cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(obj.cand_data)),
                    isHiddenCalendar: false

                }, () => {
                    this.getProiecte()
                })
                return true
            }

        }


        else {


            this.setState({
                isOpenAlertPerioadaTask: true
            }, () => {
                // console.log('this.state.dtDataStart :', this.state.dtDataStart);
            })
        }


    }

    dataFinishChange = async (ev) => {
        let fs = new FromServer();

        let u = new Utils()

        // console.warn('ev data finish--------------- :', ev);
        // console.warn('ev data etapa start', new Date(this.state.objEtapaInfo.durata_de_la))
        // console.warn('ev data etapa start', new Date(this.state.objEtapaInfo.durata_pana_la))


        if (new Date(this.state.objEtapaInfo.durata_de_la) <= ev && ev <= new Date(this.state.objEtapaInfo.durata_pana_la)) {


            let obj = {
                pana_cand_data: u.transformDataForSql(ev)
            }




            // console.warn('obj :', this.state.objInfoTask);


            let update = await fs.updateTask(obj, this.state.objInfoTask.id)


            if (update) {



                this.setState({
                    dtDataFinish: ev,
                    strDataFinish: this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(obj.pana_cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(obj.pana_cand_data)),
                    // isHiddenCalendarFinish: true

                }, () => {
                    this.getProiecte()
                })
                return true
            }
        } else if (new Date(this.state.objEtapaInfo.cand_data) <= ev && ev <= new Date(this.state.objEtapaInfo.pana_cand_data)) {
            let obj = {
                pana_cand_data: u.transformDataForSql(ev)
            }




            // console.warn('obj :', this.state.objInfoTask);


            let update = await fs.updateTask(obj, this.state.objInfoTask.id)


            if (update) {



                this.setState({
                    dtDataFinish: ev,
                    strDataFinish: this.dictionary.data === 'en' ? u.dataPrescurtataEng(u.ParseDataFromSql(obj.pana_cand_data)) : u.dataPrescurtataRomana(u.ParseDataFromSql(obj.pana_cand_data)),
                    // isHiddenCalendarFinish: true

                }, () => {
                    this.getProiecte()
                })
                return true
            }
        }

        else {


            this.setState({
                isOpenAlertPerioadaTask: true
            }, () => {
                // console.log('this.state.dtDataStart :', this.state.dtDataStart);
            })
        }
    }

    handleTaskChange = name => ev => {

        console.log('name :>> ', name);
        console.log('ev :>> ', ev);
        let objClone = { ...this.state.objInfoTask }

        objClone[name] = ev.target.value

        this.setState({ objInfoTask: objClone })
    }

    updateTaskTitle = () => {
        let fs = new FromServer();

        // console.log('titlu 1  :', this.state.objInfoTask.titlu );

        let obj = {
            titlu: this.state.objInfoTask.titlu
        }

        //  console.log('titlu 2 :', obj.titlu);

        let update = fs.updateTask(obj, this.state.objInfoTask.id)

        if (update) {
            this.getProiecte()
        }
    }

    closeEtape = (e) => {

        let fs = new FromServer();

        // console.log('e :', e);

        if (e !== null) {
            let obj = {
                id_etapa_proiect: e.id
            }

            let update = fs.updateTask(obj, this.state.objInfoTask.id)

            if (update) {
                this.setState({
                    isOpenMenuEtape: false,

                    objEtapaInfo: e
                }, () => {
                    this.getProiecte()
                })
            }
        } else {
            this.setState({ isOpenMenuEtape: false })
        }

    }

    etapeClick = () => {
        this.setState({
            isOpenMenuEtape: true
        })
    }

    closeUtilizator = async (u) => {

        let fs = new FromServer();
        // console.warn('user clicked:---------', u);
        // console.warn('task data ', this.state.objTaskSelectat)

        let ws = new Ws()

        let taskuri = [...this.state.listTaskuri]
        let subTaskuri = [...this.state.listSubTaskuri]

        for (let i = 0, n = taskuri.length; i < n; i++) {
            taskuri[i]['utilizator_view'] = false
        }


        for (let i = 0, n = subTaskuri.length; i < n; i++) {
            subTaskuri[i]['utilizator_view'] = false
        }

        if (u !== null) {
            let obj = {
                id_utilizator_responsabil: u.id,

            }

            let update = await fs.updateTask(obj, this.state.objInfoTask.id)
            console.log('update :>> ', update);
            if (update) {

                let objCloneTask = { ...this.state.objInfoTask }

                // console.log('objCloneTask :', objCloneTask);




                objCloneTask.nume = u.nume
                objCloneTask.id_utilizator_responsabil = u.id
                objCloneTask.poza = u.poza





                this.setState({
                    listTaskuri: taskuri,
                    listSubTaskuri: subTaskuri,
                    isOpenUtilizator: false,
                    objInfoTask: objCloneTask,
                    // objTaskSelectat: objCloneTask
                }, async () => {
                    //    console.log('isOpenUserMenu :', this.state.isOpenUtilizator);

                    console.log('objCloneTask :>> ', objCloneTask);
                    let email = await ws.getData('ActionsNotifications/TaskNouUser', {
                        idUser: objCloneTask.id_utilizator_responsabil,
                        idTask: objCloneTask.id,
                    })

                    console.warn('email-----------------------', email)
                    this.getProiecte()
                })
            }
        } else {

            console.log('else X :>> ');
            this.setState({
                isOpenUtilizator: false,
                listTaskuri: taskuri,
                listSubTaskuri: subTaskuri,
            }, () => {
                this.getProiecte()
            })
            // console.log('isOpenUserMenu :', this.state.isOpenUtilizator);
        }
    }


    openUserMenu = () => {
        this.setState({
            isOpenUtilizator: true
        })
    }

    updateTaskCandOra = () => {
        let fs = new FromServer();

        let obj = {
            cand_ora: this.state.objInfoTask.cand_ora
        }


        let objTask = this.state.objTaskSelectat

        objTask.cand_ora = obj.cand_ora
        // console.log('titlu :', obj.cand_ora);

        let update = fs.updateTask(obj, this.state.objInfoTask.id)

        if (update) {

            this.setState({
                objTaskSelectat: objTask
            })
            this.getProiecte()
        }
    }

    updateTaskPanaCandOra = () => {
        let fs = new FromServer();

        let obj = {
            pana_cand_ora: this.state.objInfoTask.pana_cand_ora
        }

        let objTask = this.state.objTaskSelectat

        objTask.pana_cand_ora = obj.pana_cand_ora

        // console.log('titlu :', obj.pana_cand_ora);

        let update = fs.updateTask(obj, this.state.objInfoTask.id)

        if (update) {

            this.setState({
                objTaskSelectat: objTask
            })
            this.getProiecte()
        }
    }


    updateTaskDescription = () => {
        let fs = new FromServer();

        let obj = {
            descriere: this.state.objInfoTask.descriere
        }

        // console.log('descriere :', obj.descriere);

        let update = fs.updateTask(obj, this.state.objInfoTask.id)

        if (update) {
            this.getProiecte()
        }
    }

    colorChange = (ev) => {
        //   console.log('ev.target.value :', ev.target.value);


        //   console.log('this.state.obtask :', this.state.objInfoTask);

        let fs = new FromServer();

        let cloneTaskuri = [...this.state.listTaskuri]

        let idx = cloneTaskuri.findIndex(c => c.id === this.state.objInfoTask.id)

        cloneTaskuri[idx].color = ev.target.value

        let cloneObjTaskInfo = { ...this.state.objInfoTask }

        cloneObjTaskInfo.color = ev.target.value
        let obj = {
            color: ev.target.value
        }

        let updateTask = fs.updateTask(obj, this.state.objInfoTask.id)

        if (updateTask) {
            this.setState({
                listTaskuri: cloneTaskuri,
                objInfoTask: cloneObjTaskInfo
            }, () => {
                this.getProiecte()
            })
        }


    }


    openTimpEstimatLucru = () => {
        this.setState({ isOpenTimpiLucru: false })
    }

    openListDocumente = () => {
        this.setState({ isOpenListDocumente: false })
    }


    updateExplicatieIntarziere = () => {
        let fs = new FromServer();

        let obj = {
            explicatie_intarziere: this.state.objInfoTask.explicatie_intarziere
        }

        // console.log('descriere :', obj.descriere);

        let update = fs.updateTask(obj, this.state.objInfoTask.id)

        if (update) {
            this.getProiecte()
        }
    }



    changeNumeBuget = (ev) => {
        let bugetSelectat = { ...this.state.bugetSelectat }


        bugetSelectat['nume'] = ev.target.value

        this.setState({ bugetSelectat: bugetSelectat })
    }

    changeTipBuget = (ev) => {
        let bugetSelectat = { ...this.state.bugetSelectat }

        bugetSelectat['tip'] = ev.target.value

        this.setState({ bugetSelectat: bugetSelectat })
    }



    selectBuget = async (b, t = this.state.listBugetC) => {
        let _subCosturi = this.ws.customSelect(`select * from bugete_taskuri_rows where id_cost = @p1 and isnull(sters,0) != 1`, {
            p1: b.id
        })

        let _docSubcosturi = this.ws.customSelect(`select * from bugete_taskuri_rows_documente where id_row_cost in (select id from bugete_taskuri_rows where id_cost = @p1 and isnull(sters,0) != 1)  and isnull(sters,0) != 1`, {
            p1: b.id
        })


        let [subCosturi, docSubcosturi] = await Promise.all([_subCosturi, _docSubcosturi])


        console.log('docSubcosturi :>> ', docSubcosturi);

        console.log('c :>> ', b);

        if (subCosturi.Succes && docSubcosturi.Succes) {


            if (this.state.isOpenBugetB) {
                this.setState({
                    bugetSelectat: b,
                    subCosturi: subCosturi.Content,
                    docSubcosturi: docSubcosturi.Content,
                    listBugetC: t,
                    isOpenBugetB: true
                })
            } else {
                this.setState({
                    bugetSelectat: b,
                    subCosturi: subCosturi.Content,
                    docSubcosturi: docSubcosturi.Content,
                    tipIntroducere: subCosturi.Content.length > 1 ? 'defalcata' : 'individuala',
                    listBugetC: t,
                    isOpenBugetB: true
                })
            }


        }
    }

    selectCost = async (c, t = this.state.listBugetC) => {


        let _subCosturi = await this.ws.customSelect(`select c.*, b.id_buget from costuri_taskuri_rows c left join bugete_legatura_cheltuieli b
            on c.id = b.id_cheltuiala
        where c.id_cost  = @p1 and isnull(c.sters,0) != 1 and isnull(b.sters, 0 ) != 1`, {
            p1: c.id
        })

        let _docSubcosturi = this.ws.customSelect(`select * from costuri_taskuri_rows_documente where id_row_cost in (select id from costuri_taskuri_rows where id_cost = @p1 and isnull(sters,0) != 1) and isnull(sters,0) != 1`, {
            p1: c.id
        })





        let [subCosturi, docSubcosturi] = await Promise.all([_subCosturi, _docSubcosturi])

        console.warn('c :>> ', c);
        console.log('subCosturi :>> ', subCosturi);
        console.log('docSubcosturi :>> ', docSubcosturi);
        console.log('listBugetC :>> ', t);

        if (subCosturi.Succes && docSubcosturi.Succes) {



            if (this.state.isOpenBuget) {
                this.setState({
                    cheltuialaSelectata: c,
                    subCosturi: subCosturi.Content,
                    docSubcosturi: docSubcosturi.Content,
                    listBugetC: t,
                    isOpenBuget: true
                })
            } else {
                this.setState({
                    cheltuialaSelectata: c,
                    subCosturi: subCosturi.Content,
                    docSubcosturi: docSubcosturi.Content,
                    tipIntroducere: subCosturi.Content.length > 1 ? 'defalcata' : 'individuala',
                    listBugetC: t,
                    isOpenBuget: true
                })
            }



        }


    }


    insertUpdateBuget = async () => {

        if (this.state.bugetSelectat.id) {
            let updateNumeCheltuiala = await this.ws.update('bugete_taskuri', { nume: this.state.bugetSelectat.nume || '', tip: this.state.bugetSelectat.tip || '' }, { id: this.state.bugetSelectat.id })

            console.log('updateNumeCheltuiala :>> ', updateNumeCheltuiala);
            if (updateNumeCheltuiala.Succes) {
                this.selectBuget(this.state.bugetSelectat, this.state.listBugetC)
            }

        } else {

            let insertCheltuiala = await this.ws.insert('bugete_taskuri', { nume: this.state.bugetSelectat.nume || '', tip: this.state.bugetSelectat.tip || '', data_costului: new Utils().updateSqlNow(), id_task: this.props.objInfoTask.id })

            if (insertCheltuiala.Succes) {



                let bugetSelectat = { ...this.state.bugetSelectat }

                bugetSelectat.id = insertCheltuiala.Content[0].id



                let costToAdd = { denumire: '', cantitate: 0, pret: 0, tva: 19 }

                costToAdd['id_cost'] = bugetSelectat.id


                console.log('costToAdd :>> ', costToAdd);

                let insertCost = await this.ws.insert('bugete_taskuri_rows', costToAdd)


                console.log('costToAdd :>> ', costToAdd);
                console.log('bugetSelectat :>> ', this.state.bugetSelectat);

                console.log('insertCost :>> ', insertCost);

                bugetSelectat['tip'] = 'cost_direct'

                if (insertCost.Succes) {

                    this.setState({ bugetSelectat: bugetSelectat }, () => {
                        this.selectBuget(bugetSelectat, this.state.listBugetC)
                    })
                }


            }
        }
    }


    insertOrUpdateCost = async () => {

        if (this.state.cheltuialaSelectata.id) {
            let updateNumeCheltuiala = await this.ws.update('costuri_taskuri', { nume: this.state.cheltuialaSelectata.nume || '', tip: this.state.cheltuialaSelectata.tip || '' }, { id: this.state.cheltuialaSelectata.id })

            console.log('updateNumeCheltuiala :>> ', updateNumeCheltuiala);
            if (updateNumeCheltuiala.Succes) {
                this.selectCost(this.state.cheltuialaSelectata)
            }

        } else {

            let insertCheltuiala = await this.ws.insert('costuri_taskuri', { nume: this.state.cheltuialaSelectata.nume || '', tip: this.state.cheltuialaSelectata.tip || '', data_costului: new Utils().updateSqlNow(), id_task: this.props.objInfoTask.id })

            if (insertCheltuiala.Succes) {



                let cheltuialaSelectata = { ...this.state.cheltuialaSelectata }

                cheltuialaSelectata.id = insertCheltuiala.Content[0].id



                let costToAdd = { denumire: '', cantitate: 0, pret: 0, tva: 19 }

                costToAdd['id_cost'] = cheltuialaSelectata.id

                let insertCost = await this.ws.insert('costuri_taskuri_rows', costToAdd)


                console.log('costToAdd :>> ', costToAdd);
                console.log('cheltuialaSelectata :>> ', this.state.cheltuialaSelectata);

                console.log('insertCost :>> ', insertCost);

                cheltuialaSelectata['tip'] = 'cost_direct'

                if (insertCost.Succes) {

                    this.setState({ cheltuialaSelectata: cheltuialaSelectata }, () => {
                        this.selectCost(cheltuialaSelectata)
                    })
                }


            }
        }
    }


    updateValoareTotalaBuget = async (v) => {
        let ws = new Ws()

        let obj = {
            valoare: v,

        }

        console.log('obj.valoare :>> ', obj.valoare);

        let updateBugete = await ws.update('bugete_taskuri', obj, { id: this.state.bugetSelectat.id })

        console.log('updateBugete :>> ', updateBugete);

        if (updateBugete.Succes) {
            this.setState({

                showCheltuieliTipuri: false,
                showCostNouTotal: false,
                showCheltuieli: false,
                showCostNou: false,
                isOpenBugetB: false,
                bugetSelectat: { id: null, nume: '', document_token: null, document_nume: null, document_id: null },
            }, () => {
                this.getProiecte()
            })
        }
    }


    changeCostObj = (ev, c) => {
        console.log('c :>> ', c);
        console.log('ev.target.value :>> ', ev.target.name);

        let val = ev.target.value
        let n = ev.target.name

        console.log('val :>> ', val);

        let listSubCosturi = [...this.state.subCosturi]

        let idx = listSubCosturi.findIndex(sc => sc.id === c.id)

        if (idx !== -1) {
            listSubCosturi[idx][n] = val
            this.setState({ subCosturi: listSubCosturi })
        }
    }



    changeNumeCheltuiala = (ev) => {

        let cheltuialaSelectata = { ...this.state.cheltuialaSelectata }

        cheltuialaSelectata['nume'] = ev.target.value

        this.setState({ cheltuialaSelectata: cheltuialaSelectata })
    }


    changeTip = (ev) => {
        let cheltuialaSelectata = { ...this.state.cheltuialaSelectata }

        cheltuialaSelectata['tip'] = ev.target.value

        this.setState({ cheltuialaSelectata: cheltuialaSelectata })
    }


    updateValoareCost = async (v) => {
        // console.log('v :', v);

        let ws = new Ws()

        let obj = {
            valoare: v.valoare,

        }


        let updateBugete = await ws.update('costuri_taskuri', obj, { id: v.id })


    }


    updateValoareTotalaCost = async (v) => {
        let ws = new Ws()

        let obj = {
            valoare: v,

        }

        console.log('obj.valoare :>> ', obj.valoare);

        let updateBugete = await ws.update('costuri_taskuri', obj, { id: this.state.cheltuialaSelectata.id })

        console.log('updateBugete :>> ', updateBugete);

        if (updateBugete.Succes) {
            this.setState({

                showCheltuieliTipuri: false,
                showCostNouTotal: false,
                showCheltuieli: false,
                showCostNou: false,
                isOpenBuget: false,
                cheltuialaSelectata: { id: null, nume: '', document_token: null, document_nume: null, document_id: null },
            }, () => {
                this.getProiecte()
            })
        }
    }


    clearAngajat = async () => {


        let ws = new Ws()

        let objTask = { ...this.state.objInfoTask }

        console.log('objTask :>> ', objTask);


        objTask['nume'] = 'Selecteaza user'
        objTask['id_utilizator_responsabil'] = ''
        objTask['poza'] = ''


        let updateTask = await ws.update('taskuri', { id_utilizator_responsabil: 0 }, { id: objTask.id })


        if (updateTask.Succes) {

            this.setState({ objInfoTask: objTask })
        }


    }

    render() {
        return (
            <div>

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />

                <AlertDialog
                    open={this.state.isOpenAlertPerioadaTask}
                    dialogClose={() => { this.setState({ isOpenAlertPerioadaTask: false }) }}
                    title={this.dictionary.alertDate.task}
                    limba={this.dictionary}
                    yesFunction={() => { this.setState({ isOpenAlertPerioadaTask: false }) }}
                    noButtonDisplay={1}
                />

                <AlertNew
                    open={this.state.openDeleteTask}
                    dialogClose={() => { this.setState({ openDeleteTask: false }) }}
                    title={'Doresti sa stergi taskul selectat?'}
                    mesaj={'Aceasta functie este ireversibila iar taskul nu mai poate fi recuperat ! '}
                    yesFunction={this.deleteTask}
                />

                <InsertUpdateTask
                    open={this.state.isOpenInsertTask}
                    dialogClose={this.closeTaskDialog}
                    taskCompletat={this.state.objInfoTask.statusul}
                    taskFinalizat={this.taskFinalizat}
                    dictionary={this.dictionary}
                    dataStart={this.state.strDataStart}
                    dataFinish={this.state.strDataFinish}
                    dtDataStart={this.state.dtDataStart}
                    dtDataFinish={this.state.dtDataFinish}
                    hideCalendarFinish={this.state.isHiddenCalendarFinish}
                    hideCalendar={this.state.isHiddenCalendar}
                    getPerioada={this.getPerioada}
                    showCalendarStart={() => { this.setState({ isHiddenCalendar: this.state.isHiddenCalendar ? false : true, isHiddenCalendarFinish: this.state.isHiddenCalendar ? false : true }) }}
                    showCalendarFinish={() => { this.setState({ isHiddenCalendarFinish: this.state.isHiddenCalendarFinish ? false : true, isHiddenCalendar: true }) }}
                    hideCal={this.hideCal}
                    changeResponsabil={this.changeResponsabil}
                    dataStartChange={(ev) => { this.dataStartChange(ev) }}
                    dataFinishChange={(ev) => { this.dataFinishChange(ev) }}
                    taskTitle={this.state.objInfoTask.titlu}
                    taskTitleChange={this.handleTaskChange('titlu')}
                    updateTaskTitle={this.updateTaskTitle}
                    listEtape={this.state.etape}
                    listTaskuri={this.state.listTaskuri}
                    getData={this.getProiecte}
                    isOpenMenuEtape={this.state.isOpenMenuEtape}
                    closeMenuEtape={this.closeEtape}
                    etapaTitle={this.state.objEtapaInfo.denumire}
                    etapeClick={this.etapeClick}
                    objInfoTask={this.state.objInfoTask}
                    listUsers={this.state.useriAll}
                    isUtlizatorOpen={this.state.isOpenUtilizator}
                    closeUtilizator={this.closeUtilizator}
                    userClick={this.openUserMenu}
                    listSubTaskuri={this.state.listSubTaskuri}
                    candOra={this.state.objInfoTask.cand_ora}
                    candOraChange={this.handleTaskChange('cand_ora')}
                    panaCandOra={this.state.objInfoTask.pana_cand_ora}
                    panaCandOraChange={this.handleTaskChange('pana_cand_ora')}
                    updateTaskCandOra={this.updateTaskCandOra}
                    updateTaskPanaCandOra={this.updateTaskPanaCandOra}
                    taskDescription={this.state.objInfoTask.descriere}
                    taskDescriptionChange={this.handleTaskChange('descriere')}
                    updateTaskDescription={this.updateTaskDescription}
                    openDeleteTask={() => { this.setState({ openDeleteTask: true }) }}
                    deleteTask={this.deleteTask}
                    colorChange={this.colorChange}
                    culoriTaskuri={this.state.culoriTaskuri}
                    openListTimpEstimatLucru={this.openTimpEstimatLucru}
                    openListDocumente={this.openListDocumente}
                    etapaInfo={this.state.objEtapaInfo}
                    listDocumente={this.state.listDocumenteTask}
                    getTaskData={() => { this.getTaskData(this.state.objInfoTask) }}
                    proiectInfo={this.state.objInfoProiect}
                    explicatieIntarziere={this.state.objInfoTask.explicatie_intarziere}
                    explicatieIntarziereChange={this.handleTaskChange('explicatie_intarziere')}
                    updateExplicatieIntarziere={this.updateExplicatieIntarziere}
                    ref={this.insertTaskRef}
                    clearAngajat={this.clearAngajat}

                />
                <CustomAppBar history={this.props.history} title={' '} appBarButtons={this.buildAppBarButtons()} />

                <Grid style={{ maxWidth: 1400, margin: 'auto' }} container>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.economic.economic} </h1>

                    </Grid>

                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                        <h3 style={{ textAlign: 'left', marginTop: 0 }}>
                            <i style={{ color: 'rgb(253 189 8 )', fontSize: 35, verticalAlign: 'middle' }} className='material-icons'>folder</i>
                            <span>{this.state.proiect.titlu}</span>
                        </h3>

                    </Grid>
                    <Grid style={{ textAlign: 'left' }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                        <div>
                            <span style={{ lineHeight: '34px', marginRight: 20, fontSize: 14 }}>{this.dictionary.economic.bugetTotal}:{this.state.proiect.buget} lei </span>
                            <span style={{ lineHeight: '34px', marginRight: 20, fontSize: 14 }}>{this.dictionary.economic.cheltuieliTotal}:{this.state.proiect.cost} lei </span>
                            <span style={{ lineHeight: '34px', marginRight: 20, fontSize: 14 }}>{this.dictionary.economic.profit}:{this.state.proiect.profit} lei </span>
                        </div>

                        <span style={{ lineHeight: '34px', marginRight: 20, fontSize: 14 }}>{this.dictionary.economic.sarciniCuCheltuieli}:{this.state.proiect.taskuri.filter(t => t.cheltuieli && t.cheltuieli.length > 0).length}</span>
                        <span style={{ lineHeight: '34px', marginRight: 20, fontSize: 14 }}>{this.dictionary.economic.utlilizatoriCuCheltuieli}:{this.state.utilizatoriCuCheltuieli}</span>

                    </Grid>

                    <Grid style={{ textAlign: 'left' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                        <span style={{ lineHeight: '34px', fontSize: 14 }}>{this.dictionary.economic.afisazaDupa}:

                            <i onClick={() => { this.changeView('user') }} style={{ cursor: 'pointer', verticalAlign: "sub", marginLeft: 10, fontSize: 20, color: this.state.sortType === 'user' ? 'rgb(62 138 230 )' : 'gray' }} className='material-icons'>person</i>
                            <i
                                onClick={() => { this.changeView('task') }}
                                style={{ cursor: 'pointer', verticalAlign: "sub", marginLeft: 10, fontSize: 20, color: this.state.sortType === 'task' ? 'rgb(62 138 230 )' : 'gray' }} className='material-icons'>assignment_turned_in</i>
                            {/* <i onClick={()=>{this.changeView('date')}} style={{ cursor:'pointer', verticalAlign: "sub" , marginLeft:10, fontSize:20, color:this.state.sortType === 'date' ? 'rgb(62 138 230 )' : 'gray'}} className='material-icons'>event</i> */}


                        </span>
                    </Grid>

                    {this.state.sortType === 'user' && this.state.cheltuieli.map((c, idx) => {
                        return (
                            <Grid key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid style={{ padding: 10, backgroundColor: 'white', marginTop: 40 }} container>
                                    <Grid style={{ textAlign: 'left', padding: '10px 0 20px 0' }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                        <div style={{ width: 'fit-content', height: '100%', position: 'relative', cursor: 'pointer', display: 'inline-block', textAlign: 'left' }}>


                                            <div>
                                                {
                                                    c.poza &&
                                                    <div
                                                        className='pm-angajati-picture'
                                                        style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + c.poza}')`, width: 36, height: 36 }}>

                                                    </div>
                                                }
                                                {!c.poza &&

                                                    <Avatar
                                                        className='pm-angajati-picture'
                                                        style={{ display: 'inline-block', textAlign: 'center', height: 36, width: 36, backgroundColor: new Utils().culoriUtilizatori(c.id) }}>
                                                        <i style={{ verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>person</i>
                                                    </Avatar>
                                                    // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(c.nume + ' ')} </Avatar>
                                                }
                                                <span style={{ fontWeight: 800 }} onClick={this.props.userClick} className='pm-task-change-user'>{c.nume}</span>

                                            </div>

                                        </div>
                                    </Grid>

                                    <Grid style={{ textAlign: 'left', position: 'relative' }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                        <span style={{ lineHeight: '34px', marginRight: 20, fontSize: 14, position: 'absolute', bottom: 0 }}>{this.dictionary.economic.sarciniCuCheltuieli}:{c.nr_taskuri}  </span>
                                    </Grid>

                                    <Grid style={{ textAlign: 'left', position: 'relative' }} item xs={3} sm={3} md={3} lg={3} xl={3}>

                                        <span style={{ lineHeight: '34px', marginRight: 20, fontSize: 14, position: 'absolute', bottom: 0 }}>{this.dictionary.economic.sumaCheltuieli}: {+(Math.round(c.suma_cheltuieli + "e+3") + "e-3")} lei </span>
                                    </Grid>

                                    {c.taskuri.length > 0 && c.taskuri.map((t, idxT) => {
                                        return (
                                            <Grid style={{ marginBottom: 20, backgroundColor: 'rgb(249 249 249 )', textAlign: 'left' }} key={`taskuri${idxT}`} container>
                                                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                    <span style={{ marginRight: 20, fontSize: 14, fontWeight: 600, display: 'block', lineHeight: 2 }}>{t.titlu} </span>
                                                    <span style={{ marginRight: 20, fontSize: 14, color: 'rgb(91	158	234	)', display: 'block', lineHeight: 2 }}>{t.nume_etapa} {t.nume_task_parent ? `/ ${t.nume_task_parent}` : ''} </span>
                                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', lineHeight: 2 }}> {this.dictionary.economic.perioada}: {this.u.ParseDataFromSql(t.cand_data)} - {this.u.ParseDataFromSql(t.pana_cand_data)}  </span>
                                                </Grid>
                                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.buget}:</span>
                                                    {/* <span style={{ marginRight: 20, fontSize: 12, color:'black',  fontWeight:600,  display:'block' ,lineHeight:2}}>{t.suma_buget.toFixed(3)} Lei </span> */}
                                                    <span style={{ marginRight: 20, fontSize: 14, color: 'black', fontWeight: 600, display: 'block', lineHeight: 2 }}>{+(Math.round(t.suma_buget + "e+3") + "e-3")} Lei </span>

                                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', lineHeight: 2 }}> {this.dictionary.economic.liniiBuget}:<span style={{ fontWeight: 600, }}>{t.linii_buget}</span>  </span>

                                                </Grid>
                                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.cheltuieli}:</span>
                                                    {/* <span style={{ marginRight: 20, fontSize: 12, color:'black',  fontWeight:600,  display:'block' ,lineHeight:2}}>{t.suma_cheltuieli.toFixed(3)} Lei </span> */}
                                                    <span style={{ marginRight: 20, fontSize: 14, color: 'black', fontWeight: 600, display: 'block', lineHeight: 2 }}>{+(Math.round(t.suma_cheltuieli + "e+3") + "e-3")} Lei </span>

                                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', lineHeight: 2 }}> {this.dictionary.economic.liniiChletuieli}:<span style={{ fontWeight: 600, }}>{t.linii_cheltuieli}</span>  </span>

                                                </Grid>
                                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.profit}:</span>
                                                    {/* <span style={{ marginRight: 20, fontSize: 12, color:'black',  fontWeight:600,  display:'block' ,lineHeight:2}}>{t.profit.toFixed(3)} Lei </span> */}
                                                    <span style={{ marginRight: 20, fontSize: 14, color: 'black', fontWeight: 600, display: 'block', lineHeight: 2 }}>{+(Math.round(t.profit + "e+3") + "e-3")} Lei </span>



                                                </Grid>
                                                <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.alerte}:</span>
                                                    <span style={{ marginRight: 20, fontSize: 14, color: 'black', fontWeight: 600, display: 'block', lineHeight: 2 }}>

                                                        {/* <i style={{ cursor: 'pointer', marginRight: 10, backgroundColor:'transparent', color:'rgb(227	51	59	)' }} onClick={() => { this.selectCost(c) }} className='material-icons pm-standard-icons'>error</i> */}


                                                    </span>

                                                </Grid>
                                                <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                    <span style={{ fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.operatiuni}:</span>
                                                    <span style={{ fontSize: 14, color: 'black', fontWeight: 600, display: 'block', lineHeight: 2 }}>
                                                        <i onClick={() => { this.getTaskData(t) }} style={{ cursor: 'pointer', marginRight: 10 }} className='material-icons pm-standard-icons'>create</i>
                                                        <i onClick={() => { this.dropDownTask(c, t) }} style={{ cursor: 'pointer', marginRight: 10 }} className='material-icons pm-standard-icons'>{t.open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>
                                                    </span>

                                                </Grid>


                                                {t.open &&
                                                    <table className='cheltuieli-rows' style={{
                                                        borderCollapse: 'collapse', textAlign: 'left', fontSize: 14, marginTop: 20, tableLayout: 'auto',

                                                        // backgroundColor: 'rgb(241 241 241)'

                                                    }}>
                                                        <thead>

                                                            <tr>
                                                                <th style={{ width: '33%' }} >{this.dictionary.economic.denumireBuget}</th>
                                                                <th style={{ width: '17%' }}>{this.dictionary.economic.valoareBuget}</th>
                                                                <th style={{ width: '17%' }}>{this.dictionary.economic.cheltuiala}</th>
                                                                <th style={{ width: '10%' }}>{this.dictionary.economic.profit}</th>
                                                                <th style={{ width: '7%' }}> <i style={{ cursor: 'pointer', marginRight: 10 }} className='material-icons pm-standard-icons'>attachment</i>
                                                                </th>
                                                                <th>{this.dictionary.economic.modificat}</th>
                                                                <th></th>



                                                            </tr>

                                                        </thead>
                                                        {t.bugete.map((b, idxB) => {
                                                            return (
                                                                <tbody style={{ backgroundColor: b.open ? 'white' : '' }} key={`bugete${idxB}`}>


                                                                    <tr >
                                                                        <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{b.nume}</span></td>

                                                                        {/* <td> <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(b.valoare).toFixed(3)} Lei</span></td>  */}
                                                                        <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>  {+(Math.round(b.valoare + "e+3") + "e-3")} Lei</span></td>

                                                                        {/* <td> <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(b.cheltuiala).toFixed(3)} Lei</span></td>   */}
                                                                        <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{+(Math.round(b.cheltuiala + "e+3") + "e-3")}  Lei</span></td>

                                                                        {/* <td> <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(b.profit).toFixed(3)}</span></td>   */}
                                                                        <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{+(Math.round(b.profit + "e+3") + "e-3")}</span></td>

                                                                        <td style={{ paddingLeft: 10 }}> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{b.nr_documente}</span></td>
                                                                        <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.u.ParseDataFromSql(b.data_costului)}</span></td>
                                                                        <td style={{ textAlign: 'right' }}> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>
                                                                            <i onClick={() => { this.dropDownSubBuget(c, t, b) }} style={{ cursor: 'pointer', marginRight: 10, backgroundColor: b.open ? 'black' : '', color: b.open ? 'white' : '' }} className='material-icons pm-standard-icons'>{b.open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>

                                                                            <i onClick={() => { this.selectBuget(b, t.bugete) }} style={{ cursor: 'pointer', marginRight: 10 }} className='material-icons pm-standard-icons'>visibility</i>
                                                                        </span></td>





                                                                    </tr>




                                                                    {b.open &&


                                                                        <tr style={{ paddingLeft: 20 }}>
                                                                            <th style={{ padding: 'inherit' }}>{this.dictionary.economic.denumireProdusServiciu}</th>
                                                                            <th >{this.dictionary.economic.cantitate}</th>
                                                                            <th >{this.dictionary.economic.pret}</th>
                                                                            <th >{this.dictionary.economic.tva}</th>
                                                                            <th >{this.dictionary.economic.totalPlusTva}</th>
                                                                            <th></th>



                                                                            <th></th>



                                                                        </tr>
                                                                    }




                                                                    {b.open && b.bugete_rows.map((bR, idxBR) => {
                                                                        return (


                                                                            <tr style={{ paddingLeft: 20, backgroundColor: 'white' }} key={`bugete_rows${idxBR}`}>
                                                                                <td style={{ padding: 'inherit' }}> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{
                                                                                
                                                                                b.tip === 'cost_personal' ? 
                                                                                bR.nume_angajat :
                                                                                bR.denumire
                                                                                }</span></td>

                                                                                {/* <td> <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(bR.cantitate).toFixed(3)} </span></td>  */}
                                                                                <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}> {+(Math.round(bR.cantitate + "e+3") + "e-3")} </span></td>

                                                                                {/* <td> <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(bR.pret).toFixed(3)} Lei</span></td>  */}
                                                                                <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{+(Math.round(bR.cantitate + "e+3") + "e-3")}  Lei</span></td>

                                                                                <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{bR.tva}%</span></td>
                                                                                {/* <td > <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(bR.total).toFixed(3)}</span></td>   */}
                                                                                <td > <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{+(Math.round(bR.total + "e+3") + "e-3")}</span></td>

                                                                                <td></td>

                                                                                <td style={{ textAlign: 'right' }}> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>
                                                                                    <i onClick={() => { this.selectBuget(b, t.bugete) }} style={{ cursor: 'pointer', marginRight: 10 }} className='material-icons pm-standard-icons'>visibility</i>
                                                                                </span></td>

                                                                            </tr>


                                                                        )
                                                                    })}











                                                                </tbody>
                                                            )
                                                        })}

                                                    </table>
                                                }

                                                {t.open &&
                                                    <table className='cheltuieli-rows' style={{
                                                        borderCollapse: 'collapse', textAlign: 'left', fontSize: 14, marginTop: 20, tableLayout: 'auto',

                                                        // backgroundColor: 'rgb(241 241 241)'

                                                    }}>
                                                        <thead>

                                                            <tr>
                                                                <th style={{ width: '33%' }} >{this.dictionary.economic.denumireCheltuiala}</th>
                                                                <th style={{ width: '17%' }}>{this.dictionary.economic.valoareCheltuiala}</th>
                                                                <th style={{ width: '17%' }}></th>
                                                                <th style={{ width: '10%' }}></th>
                                                                <th style={{ width: '7%' }}> <i style={{ cursor: 'pointer', marginRight: 10 }} className='material-icons pm-standard-icons'>attachment</i>
                                                                </th>
                                                                <th>{this.dictionary.economic.modificat}</th>
                                                                <th></th>



                                                            </tr>

                                                        </thead>

                                                        {t.cheltuieli.map((b, idxC) => {
                                                            return (
                                                                <tbody style={{ backgroundColor: b.open ? 'white' : '' }} key={`cheltuieli${idxC}`}>
                                                                    <tr >
                                                                        <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{b.nume}</span></td>

                                                                        {/* <td> <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(b.valoare).toFixed(3)} Lei</span></td> */}
                                                                        <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>  {+(Math.round(b.valoare + "e+3") + "e-3")} Lei</span></td>

                                                                        <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}></span></td>
                                                                        <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}></span></td>
                                                                        <td style={{ paddingLeft: 10 }}> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{b.nr_documente}</span></td>
                                                                        <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.u.ParseDataFromSql(b.data_costului)}</span></td>
                                                                        <td style={{ textAlign: 'right' }}> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>
                                                                            <i onClick={() => { this.dropDownSubCheltuiala(c, t, b) }} style={{ cursor: 'pointer', marginRight: 10, backgroundColor: b.open ? 'black' : '', color: b.open ? 'white' : '' }} className='material-icons pm-standard-icons'>{b.open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>

                                                                            <i onClick={() => { this.selectCost(b, t.bugete) }} style={{ cursor: 'pointer', marginRight: 10 }} className='material-icons pm-standard-icons'>visibility</i>
                                                                        </span></td>





                                                                    </tr>

                                                                    {b.open &&


                                                                        <tr style={{ paddingLeft: 20 }}>
                                                                            <th style={{ padding: 'inherit' }}>{this.dictionary.economic.denumireProdusServiciu}</th>
                                                                            <th >{this.dictionary.economic.cantitate}</th>
                                                                            <th >{this.dictionary.economic.pret}</th>
                                                                            <th >{this.dictionary.economic.tva}</th>
                                                                            <th >{this.dictionary.economic.totalPlusTva}</th>
                                                                            <th>{this.dictionary.economic.alocatLaBuget}</th>
                                                                            <th></th>



                                                                        </tr>
                                                                    }




                                                                    {b.open && b.costuri_rows.map((bR, idxCr) => {
                                                                        return (


                                                                            <tr style={{ paddingLeft: 20, backgroundColor: 'white' }} key={`cheltuieli_rows${idxCr}`}>
                                                                                <td style={{ padding: 'inherit' }}> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{
                                                                                       b.tip === 'cost_personal' ? 
                                                                                       bR.nume_angajat :
                                                                                       bR.denumire
                                                                                }</span></td>
                                                                                <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{bR.cantitate} </span></td>

                                                                                {/* <td> <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(bR.pret).toFixed(3)} Lei</span></td>   */}
                                                                                <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>   {+(Math.round(bR.pret + "e+3") + "e-3")}  Lei</span></td>

                                                                                <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{bR.tva}%</span></td>
                                                                                {/* <td > <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(bR.total).toFixed(3)}</span></td>   */}
                                                                                <td > <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}> {+(Math.round(bR.total + "e+3") + "e-3")} </span></td>

                                                                                <td > <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{bR.denumire_buget}</span></td>


                                                                                <td style={{ textAlign: 'right' }}> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>
                                                                                    <i onClick={() => { this.selectCost(b, t.bugete) }} style={{ cursor: 'pointer', marginRight: 10 }} className='material-icons pm-standard-icons'>visibility</i>
                                                                                </span></td>

                                                                            </tr>


                                                                        )
                                                                    })}


                                                                </tbody>
                                                            )
                                                        })}

                                                    </table>
                                                }
                                            </Grid>
                                        )
                                    })




                                    }



                                    {c.taskuri.length === 0 &&
                                        <h4> {this.dictionary.economic.acestUtilizatorNuAreCheltuieli}</h4>
                                    }


                                </Grid>

                            </Grid>
                        )
                    })}


                    {this.state.sortType === 'task' && this.state.cheltuieli.length > 0 && this.state.cheltuieli.map((e, idx3) => {
                        return (



                            <Grid key={idx3} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid style={{
                                    marginTop: 40, borderBottom: '1px solid #d2d2d2',
                                    paddingBottom: 20,
                                    textAlign: 'left'
                                }} container>
                                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                        <span style={{ fontSize: 14, color: 'rgb(91	158	234	)', display: 'block', lineHeight: 2 }}>{this.dictionary.economic.etapa} </span>

                                        <span style={{ fontSize: 18, fontWeight: 600, display: 'block', lineHeight: 2 }}>{e.denumire} </span>
                                        <span style={{ fontSize: 14, display: 'block', lineHeight: 2 }}> {this.dictionary.economic.perioada}: {e.durata_de_la} - {e.durata_pana_la}  </span>
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.buget}:</span>

                                        {/* <span style={{ marginRight: 20, fontSize: 12, color:'black',  fontWeight:600,  display:'block' ,lineHeight:2}}>{t.suma_buget.toFixed(3)} Lei </span> */}
                                        <span style={{ marginRight: 20, fontSize: 14, color: 'black', fontWeight: 600, display: 'block', lineHeight: 2 }}> {+(Math.round(e.valoare_buget + "e+3") + "e-3")} Lei </span>

                                        <span style={{ marginRight: 20, fontSize: 12, display: 'block', lineHeight: 2 }}> {this.dictionary.economic.liniiBuget}:  <span style={{ fontWeight: 600, }}>{e.linii_buget}</span> </span>

                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.cheltuieli}:</span>
                                        {/* <span style={{ marginRight: 20, fontSize: 12, color:'black',  fontWeight:600,  display:'block' ,lineHeight:2}}>{t.suma_cheltuieli.toFixed(3)} Lei </span> */}
                                        <span style={{ marginRight: 20, fontSize: 14, color: 'black', fontWeight: 600, display: 'block', lineHeight: 2 }}>{+(Math.round(e.valoare_cheltuieli + "e+3") + "e-3")}  Lei </span>

                                        <span style={{ marginRight: 20, fontSize: 12, display: 'block', lineHeight: 2 }}> {this.dictionary.economic.liniiCheltuieli}: <span style={{ fontWeight: 600, }}>{e.linii_cheltuieli}</span>  </span>

                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.profit}:</span>
                                        {/* <span style={{ marginRight: 20, fontSize: 12, color:'black',  fontWeight:600,  display:'block' ,lineHeight:2}}>{t.profit.toFixed(3)} Lei </span> */}
                                        <span style={{ marginRight: 20, fontSize: 14, color: 'black', fontWeight: 600, display: 'block', lineHeight: 2 }}>{+(Math.round((Number(e.valoare_buget) - Number(e.valoare_cheltuieli)) + "e+3") + "e-3")} Lei </span>



                                    </Grid>
                                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                        <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.alerte}:</span>
                                        <span style={{ marginRight: 20, fontSize: 14, color: 'black', fontWeight: 600, display: 'block', lineHeight: 2 }}>

                                            {/* <i style={{ cursor: 'pointer', marginRight: 10, backgroundColor:'transparent', color:'rgb(227	51	59	)' }} onClick={() => { this.selectCost(c) }} className='material-icons pm-standard-icons'>error</i> */}


                                        </span>

                                    </Grid>
                                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                        <span style={{ fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.operatiuni}:</span>
                                        <span style={{ fontSize: 14, color: 'black', fontWeight: 600, display: 'block', lineHeight: 2 }}>
                                            <i onClick={() => { this.dropDownEtapa(e) }} style={{ cursor: 'pointer', marginRight: 10 }} className='material-icons pm-standard-icons'>{e.open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>


                                        </span>

                                    </Grid>



                                    {e.open && e.taskuri.map((t, idx) => {
                                        return (
                                            <Grid key={'Task' + idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Grid style={{ padding: 10, backgroundColor: 'white', marginTop: 40, textAlign: 'left' }} container>
                                                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                        <span style={{ marginRight: 20, fontSize: 14, fontWeight: 600, display: 'block', lineHeight: 2 }}>{t.titlu} </span>
                                                        {/* <span style={{ marginRight: 20, fontSize: 12, color:'rgb(91	158	234	)',  display:'block' ,lineHeight:2}}>{t.nume_etapa} {t.nume_task_parent ? `/ ${t.nume_task_parent}` : '' } </span> */}
                                                        <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}> {this.dictionary.economic.perioada}: {this.u.ParseDataFromSql(t.cand_data)} - {this.u.ParseDataFromSql(t.pana_cand_data)}  </span>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.buget}:</span>

                                                        {/* <span style={{ marginRight: 20, fontSize: 12, color:'black',  fontWeight:600,  display:'block' ,lineHeight:2}}>{t.suma_buget.toFixed(3)} Lei </span> */}
                                                        <span style={{ marginRight: 20, fontSize: 14, color: 'black', fontWeight: 600, display: 'block', lineHeight: 2 }}> {+(Math.round(t.suma_buget + "e+3") + "e-3")} Lei </span>

                                                        <span style={{ marginRight: 20, fontSize: 12, display: 'block', lineHeight: 2 }}> {this.dictionary.economic.liniiBuget}:  <span style={{ fontWeight: 600, }}>{t.linii_buget}</span> </span>

                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.cheltuieli}:</span>
                                                        {/* <span style={{ marginRight: 20, fontSize: 12, color:'black',  fontWeight:600,  display:'block' ,lineHeight:2}}>{t.suma_cheltuieli.toFixed(3)} Lei </span> */}
                                                        <span style={{ marginRight: 20, fontSize: 14, color: 'black', fontWeight: 600, display: 'block', lineHeight: 2 }}>{+(Math.round(t.suma_cheltuieli + "e+3") + "e-3")}  Lei </span>

                                                        <span style={{ marginRight: 20, fontSize: 12, display: 'block', lineHeight: 2 }}> {this.dictionary.economic.liniiCheltuieli}: <span style={{ fontWeight: 600, }}>{t.linii_cheltuieli}</span>  </span>

                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.profit}:</span>
                                                        {/* <span style={{ marginRight: 20, fontSize: 12, color:'black',  fontWeight:600,  display:'block' ,lineHeight:2}}>{t.profit.toFixed(3)} Lei </span> */}
                                                        <span style={{ marginRight: 20, fontSize: 14, color: 'black', fontWeight: 600, display: 'block', lineHeight: 2 }}>{+(Math.round(t.profit + "e+3") + "e-3")} Lei </span>



                                                    </Grid>
                                                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                        <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.alerte}:</span>
                                                        <span style={{ marginRight: 20, fontSize: 14, color: 'black', fontWeight: 600, display: 'block', lineHeight: 2 }}>

                                                            {/* <i style={{ cursor: 'pointer', marginRight: 10, backgroundColor:'transparent', color:'rgb(227	51	59	)' }} onClick={() => { this.selectCost(c) }} className='material-icons pm-standard-icons'>error</i> */}


                                                        </span>

                                                    </Grid>
                                                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                        <span style={{ fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.operatiuni}:</span>
                                                        <span style={{ fontSize: 14, color: 'black', fontWeight: 600, display: 'block', lineHeight: 2 }}>
                                                            <i onClick={() => { this.getTaskData(t) }} style={{ cursor: 'pointer', marginRight: 10 }} className='material-icons pm-standard-icons'>create</i>

                                                        </span>

                                                    </Grid>
                                                    {t.useri && t.useri.map((c, idxC) => {
                                                        return (
                                                            <Grid style={{ backgroundColor: 'rgb(249	249	249)', padding: 10 }} key={idxC} container>
                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                    <Grid style={{ textAlign: 'left' }} container>

                                                                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                                            <div style={{ width: 'fit-content', height: '100%', position: 'relative', cursor: 'pointer', display: 'inline-block', textAlign: 'left' }}>


                                                                                <div>
                                                                                    {
                                                                                        c.poza &&
                                                                                        <div
                                                                                            className='pm-angajati-picture'
                                                                                            style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + c.poza}')`, width: 36, height: 36 }}>

                                                                                        </div>
                                                                                    }
                                                                                    {!c.poza &&

                                                                                        <Avatar
                                                                                            className='pm-angajati-picture'
                                                                                            style={{ display: 'inline-block', textAlign: 'center', height: 36, width: 36, backgroundColor: new Utils().culoriUtilizatori(c.id) }}>
                                                                                            <i style={{ verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>person</i>
                                                                                        </Avatar>
                                                                                        // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(c.nume + ' ')} </Avatar>
                                                                                    }
                                                                                    <span style={{ fontWeight: 800 }} onClick={this.props.userClick} className='pm-task-change-user'>{c.nume}</span>

                                                                                </div>

                                                                            </div>

                                                                        </Grid>


                                                                        <Grid style={{ paddingTop: 10 }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.cheltuieli}:<span style={{ fontWeight: 600 }}>{t.linii_cheltuieli}</span></span>
                                                                        </Grid>
                                                                        <Grid style={{ paddingTop: 10 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                                            {/* <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>Valoare:<span style={{fontWeight:600}}>{t.suma_cheltuieli.toFixed(3)}</span></span> */}
                                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.valoare}:<span style={{ fontWeight: 600 }}>  {+(Math.round(t.suma_cheltuieli + "e+3") + "e-3")}</span></span>

                                                                        </Grid>
                                                                        <Grid style={{ paddingTop: 10 }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.dictionary.economic.atasamente}:<span style={{ fontWeight: 600 }}>{t.nr_doc}</span></span>
                                                                        </Grid>
                                                                        <Grid style={{ paddingTop: 10 }} item xs={1} sm={1} md={1} lg={1} xl={1}>

                                                                            <span style={{ marginRight: 20, fontSize: 14, color: 'black', fontWeight: 600, display: 'block', lineHeight: 2 }}>

                                                                                {/* <i style={{ cursor: 'pointer', marginRight: 10, backgroundColor:'transparent', color:'rgb(227	51	59	)' }} onClick={() => { this.selectCost(c) }} className='material-icons pm-standard-icons'>error</i> */}


                                                                            </span>

                                                                        </Grid>
                                                                        <Grid style={{ paddingTop: 10 }} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                                            <i onClick={() => { this.dropDownTask(t, c) }} style={{ cursor: 'pointer', marginRight: 10 }} className='material-icons pm-standard-icons'>{t.open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>


                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>

                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                    {t.open &&
                                                                        <table className='cheltuieli-rows' style={{ borderCollapse: 'collapse', textAlign: 'left', fontSize: 14, marginTop: 20, tableLayout: 'auto', backgroundColor: 'rgb(241 241 241)' }}>
                                                                            <thead>

                                                                                <tr>
                                                                                    <th style={{ width: '33%' }} >{this.dictionary.economic.denumireBuget}</th>
                                                                                    <th style={{ width: '17%' }}>{this.dictionary.economic.valoareBuget}</th>
                                                                                    <th style={{ width: '17%' }}>{this.dictionary.economic.cheltuiala}</th>
                                                                                    <th style={{ width: '10%' }}>{this.dictionary.economic.profit}</th>
                                                                                    <th style={{ width: '7%' }}> <i style={{ cursor: 'pointer', marginRight: 10 }} className='material-icons pm-standard-icons'>attachment</i>
                                                                                    </th>
                                                                                    <th>{this.dictionary.economic.modificat}</th>
                                                                                    <th></th>



                                                                                </tr>

                                                                            </thead>
                                                                            {t.bugete.map((b, idxB) => {
                                                                                return (
                                                                                    <tbody style={{ backgroundColor: b.open ? 'white' : '' }} key={`bugete${idxB}`}>


                                                                                        <tr >
                                                                                            <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{b.nume}</span></td>

                                                                                            {/* <td> <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(b.valoare).toFixed(3)} Lei</span></td>   */}
                                                                                            <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>   {+(Math.round(b.valoare + "e+3") + "e-3")} Lei</span></td>

                                                                                            {/* <td> <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(b.cheltuiala).toFixed(3)} Lei</span></td>  */}
                                                                                            <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{+(Math.round(b.cheltuiala + "e+3") + "e-3")} Lei</span></td>

                                                                                            {/* <td> <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(b.profit).toFixed(3)}</span></td>   */}
                                                                                            <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{+(Math.round(b.profit + "e+3") + "e-3")}</span></td>

                                                                                            <td style={{ paddingLeft: 10 }}> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{b.nr_documente}</span></td>
                                                                                            <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.u.ParseDataFromSql(b.data_costului)}</span></td>
                                                                                            <td style={{ textAlign: 'right' }}> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>
                                                                                                <i onClick={() => { this.dropDownSubBuget(t, c, b) }} style={{ cursor: 'pointer', marginRight: 10, backgroundColor: b.open ? 'black' : '', color: b.open ? 'white' : '' }} className='material-icons pm-standard-icons'>{b.open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>

                                                                                                <i onClick={() => { this.selectBuget(b, t.bugete) }} style={{ cursor: 'pointer', marginRight: 10 }} className='material-icons pm-standard-icons'>visibility</i>
                                                                                            </span></td>





                                                                                        </tr>




                                                                                        {b.open &&


                                                                                            <tr style={{ paddingLeft: 20 }}>
                                                                                                <th style={{ padding: 'inherit' }}>{this.dictionary.economic.denumireProdusServiciu}</th>
                                                                                                <th >{this.dictionary.economic.cantitate}</th>
                                                                                                <th >{this.dictionary.economic.pret}</th>
                                                                                                <th >{this.dictionary.economic.tva}</th>
                                                                                                <th >{this.dictionary.economic.totalPlusTva}</th>
                                                                                                <th></th>



                                                                                                <th></th>



                                                                                            </tr>
                                                                                        }




                                                                                        {b.open && b.bugete_rows.map((bR, idxBR) => {
                                                                                            return (


                                                                                                <tr style={{ paddingLeft: 20, backgroundColor: 'white' }} key={`bugete_rows${idxBR}`}>
                                                                                                    <td style={{ padding: 'inherit' }}> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>
                                                                                                        {
                                                                                                        b.tip === 'cost_personal' ? 
                                                                                                        bR.nume_angajat :
                                                                                                        bR.denumire
                                                                                                        
                                                                                                        }</span></td>

                                                                                                    {/* <td> <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(bR.cantitate).toFixed(3)} </span></td>   */}
                                                                                                    <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>   {+(Math.round(bR.cantitate + "e+3") + "e-3")} </span></td>

                                                                                                    {/* <td> <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(bR.pret).toFixed(3)} Lei</span></td>   */}
                                                                                                    <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}> {+(Math.round(bR.pret + "e+3") + "e-3")} Lei</span></td>

                                                                                                    <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{bR.tva}%</span></td>
                                                                                                    {/* <td > <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(bR.total).toFixed(3)}</span></td>   */}
                                                                                                    <td > <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{+(Math.round(bR.total + "e+3") + "e-3")}</span></td>

                                                                                                    <td></td>

                                                                                                    <td style={{ textAlign: 'right' }}> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>
                                                                                                        <i onClick={() => { this.selectBuget(b, t.bugete) }} style={{ cursor: 'pointer', marginRight: 10 }} className='material-icons pm-standard-icons'>visibility</i>
                                                                                                    </span></td>

                                                                                                </tr>


                                                                                            )
                                                                                        })}











                                                                                    </tbody>
                                                                                )
                                                                            })}

                                                                        </table>
                                                                    }

                                                                    {t.open &&
                                                                        <table className='cheltuieli-rows' style={{ borderCollapse: 'collapse', textAlign: 'left', fontSize: 14, marginTop: 20, tableLayout: 'auto', backgroundColor: 'rgb(241 241 241)' }}>
                                                                            <thead>

                                                                                <tr>
                                                                                    <th style={{ width: '33%' }} >{this.dictionary.economic.denumireCheltuiala}</th>
                                                                                    <th style={{ width: '17%' }}>{this.dictionary.economic.valoareCheltuiala}</th>
                                                                                    <th style={{ width: '17%' }}></th>
                                                                                    <th style={{ width: '10%' }}></th>
                                                                                    <th style={{ width: '7%' }}> <i style={{ cursor: 'pointer', marginRight: 10 }} className='material-icons pm-standard-icons'>attachment</i>
                                                                                    </th>
                                                                                    <th>{this.dictionary.economic.modificat}</th>
                                                                                    <th></th>



                                                                                </tr>

                                                                            </thead>

                                                                            {t.cheltuieli.map((b, idxC) => {
                                                                                return (
                                                                                    <tbody style={{ backgroundColor: b.open ? 'white' : '' }} key={`cheltuieli${idxC}`}>
                                                                                        <tr >
                                                                                            <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{b.nume}</span></td>

                                                                                            {/* <td> <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(b.valoare).toFixed(3)} Lei</span></td>   */}
                                                                                            <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>  {+(Math.round(b.valoare + "e+3") + "e-3")} Lei</span></td>

                                                                                            <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}></span></td>
                                                                                            <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}></span></td>
                                                                                            <td style={{ paddingLeft: 10 }}> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{b.nr_documente}</span></td>
                                                                                            <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{this.u.ParseDataFromSql(b.data_costului)}</span></td>
                                                                                            <td style={{ textAlign: 'right' }}> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>
                                                                                                <i onClick={() => { this.dropDownSubCheltuiala(t, c, b) }} style={{ cursor: 'pointer', marginRight: 10, backgroundColor: b.open ? 'black' : '', color: b.open ? 'white' : '' }} className='material-icons pm-standard-icons'>{b.open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>

                                                                                                <i onClick={() => { this.selectCost(b, t.bugete) }} style={{ cursor: 'pointer', marginRight: 10 }} className='material-icons pm-standard-icons'>visibility</i>
                                                                                            </span></td>





                                                                                        </tr>

                                                                                        {b.open &&


                                                                                            <tr style={{ paddingLeft: 20 }}>
                                                                                                <th style={{ padding: 'inherit' }}>{this.dictionary.economic.denumireProdusServiciu}</th>
                                                                                                <th >{this.dictionary.economic.cantitate}</th>
                                                                                                <th >{this.dictionary.economic.pret}</th>
                                                                                                <th >{this.dictionary.economic.tva}</th>
                                                                                                <th >{this.dictionary.economic.totalPlusTva}</th>
                                                                                                <th>{this.dictionary.economic.alocatLaBuget}</th>
                                                                                                <th></th>



                                                                                            </tr>
                                                                                        }




                                                                                        {b.open && b.costuri_rows.map((bR, idxCr) => {
                                                                                            return (


                                                                                                <tr style={{ paddingLeft: 20, backgroundColor: 'white' }} key={`cheltuieli_rows${idxCr}`}>
                                                                                                    <td style={{ padding: 'inherit' }}> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{
                                                                                                           b.tip === 'cost_personal' ? 
                                                                                                           bR.nume_angajat :
                                                                                                           bR.denumire
                                                                                                    }</span></td>

                                                                                                    {/* <td> <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(bR.cantitate).toFixed(3)} </span></td>   */}
                                                                                                    <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>  {+(Math.round(bR.cantitate + "e+3") + "e-3")} </span></td>

                                                                                                    {/* <td> <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(bR.pret).toFixed(3)} Lei</span></td>   */}
                                                                                                    <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{+(Math.round(bR.pret + "e+3") + "e-3")} Lei</span></td>

                                                                                                    <td> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{bR.tva}%</span></td>
                                                                                                    {/* <td > <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>{Number(bR.total).toFixed(3)}</span></td>   */}
                                                                                                    <td > <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{+(Math.round(bR.total + "e+3") + "e-3")}</span></td>

                                                                                                    <td > <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>{bR.denumire_buget}</span></td>


                                                                                                    <td style={{ textAlign: 'right' }}> <span style={{ marginRight: 20, fontSize: 14, display: 'block', lineHeight: 2 }}>
                                                                                                        <i onClick={() => { this.selectCost(b, t.bugete) }} style={{ cursor: 'pointer', marginRight: 10 }} className='material-icons pm-standard-icons'>visibility</i>
                                                                                                    </span></td>

                                                                                                </tr>


                                                                                            )
                                                                                        })}


                                                                                    </tbody>
                                                                                )
                                                                            })}

                                                                        </table>
                                                                    }
                                                                </Grid>

                                                            </Grid>
                                                        )
                                                    })}



                                                </Grid>
                                            </Grid>

                                        )
                                    })}


                                </Grid>


                            </Grid>

                        )
                    })}




                </Grid>


                <BugetEtapaTaskB
                    open={this.state.isOpenBugetB}
                    cheltuialaSelectata={this.state.bugetSelectat}
                    changeNumeCheltuiala={this.changeNumeBuget}
                    tipCost={this.state.bugetSelectat.tip}
                    tipuriCost={[{ id: 'cost_direct', nume: this.dictionary.economic.direct }, { id: 'cost_personal', nume: this.dictionary.economic.bugetCuPersonal }]}
                    changeTip={this.changeTipBuget}
                    numeCost={this.state.bugetSelectat.nume}
                    subCosturi={this.state.subCosturi}
                    getSubCosturi={this.selectBuget}
                    objInfoTask={this.state.objInfoTask}
                    proiectInfo={this.state.proiectInfo}
                    getTaskData={this.getTaskData}
                    insertOrUpdateCost={this.insertUpdateBuget}
                    updateCost={this.updateValoareTotalaBuget}
                    scop={'task'}
                    changeObj={this.changeCostObj}
                    idEtapa={this.state.objInfoTask.id}
                    title={'Buget Task ' + this.state.objInfoTask.titlu}
                    dialogClose={() => { this.setState({ isOpenBugetB: false }) }}
                    tipIntroducere={this.state.tipIntroducere}
                    changeTipIntroducere={(ev) => { this.setState({ tipIntroducere: ev.target.value }) }}
                    tipuriIntroducere={this.state.tipuriIntroducereB}
                    bugete={this.state.listBugetC}
                    docSubcosturi={this.state.docSubcosturi}
                    listDocumente={this.state.listDocumenteTask}
                    selectCost={this.selectBuget}
                    listUsers={this.state.useriAll}
                />

                <BugetEtapaTask
                    open={this.state.isOpenBuget}
                    cheltuialaSelectata={this.state.cheltuialaSelectata}
                    changeNumeCheltuiala={this.changeNumeCheltuiala}
                    tipCost={this.state.cheltuialaSelectata.tip}
                    tipuriCost={[{ id: 'cost_direct', nume: this.dictionary.economic.direct }, { id: 'cost_personal', nume: this.dictionary.economic.cheltuialaCuPersonal }]}
                    changeTip={this.changeTip}
                    numeCost={this.state.cheltuialaSelectata.nume}
                    subCosturi={this.state.subCosturi}
                    getSubCosturi={this.selectCost}
                    objInfoTask={this.state.objInfoTask}
                    proiectInfo={this.state.proiectInfo}
                    getTaskData={this.getTaskData}
                    insertOrUpdateCost={this.insertOrUpdateCost}
                    updateCost={this.updateValoareTotalaCost}
                    scop={'task'}
                    changeObj={this.changeCostObj}
                    idEtapa={this.state.objInfoTask.id}
                    title={this.dictionary.economic.bugetTask + this.state.objInfoTask.titlu}
                    dialogClose={() => { this.setState({ isOpenBuget: false }) }}
                    tipIntroducere={this.state.tipIntroducere}
                    changeTipIntroducere={(ev) => { this.setState({ tipIntroducere: ev.target.value }) }}
                    tipuriIntroducere={this.state.tipuriIntroducere}
                    bugete={this.state.listBugetC}
                    docSubcosturi={this.state.docSubcosturi}
                    listDocumente={this.state.listDocumenteTask}
                    selectCost={this.selectCost}
                    listUsers={this.state.useriAll}
                />

                <BugetAssign
                    open={this.state.openBuget}
                    dialogClose={() => { this.setState({ openBuget: false }) }}
                    title={`${this.dictionary.economic.bugetAlocatCheltuielii} ${this.state.cheltuialaSelectata.nume}`}
                    bugete={this.state.bugete}
                    getData={this.getProiecte}
                    cheltuialaSelectata={this.state.cheltuialaSelectata}
                    selecteazaBuget={this.selecteazaBuget}
                />

            </div >
        );
    }
}

// {c.taskuri.length > 0 &&

//     <Grid  style={{ padding:'10px 0 20px 0'}}  item xs={12} sm={12} md={12} lg={12} xl={12}>
//     <table style={{    width: '100%',
//                         borderCollapse: 'collapse',
//                         tableLayout: 'auto',
//                         textAlign:'left'}}>
//         <thead>
//             <tr style={{borderBottom:'1px solid gray', fontSize:12, lineHeight:'34px'}}>
//                 <th>Data</th>
//                 <th>Nume Sarcina</th>
//                 <th>Nume Cheltuiala</th>
//                 <th>Buget Cheltuiala</th>
//                 <th>Valoare Cheltuiala</th>
//                 <th>Profit/Pierdere</th>
//                 <th>Operatiuni</th>

//             </tr>
//         </thead>
//         <tbody>
//             {c.cheltuieli.map((ch, idx2)=>{

//                 if(!ch.edit){
//                     return(


//                         <tr key={'ch'+idx2} style={{borderBottom:'1px solid gray', fontSize:12, lineHeight:'34px'}}>

//                             <td>{new Utils().ParseDataFromSql(ch.data_costului)}</td>
//                     <td>{ch.nume_task}</td>
//                     <td>{ch.nume}</td>
//                     <td>{ch.valoare_buget}lei</td>
//                     <td>{(ch.valoare || 0) + ((c.valoare || 0) * (c.tva || 0) / 100)} lei</td>
//                     <td>{ch.profit || 0 } lei</td>
//                     <td style={{position:'relative'}}>


//                      <div className='etapa-tag' style={{
//                                     position: 'absolute', 
//                                     display: ch.show_tag ? 'block' : 'none',
//                                     // display:idx2 === 0 ? 'block' :'none',

//                                     bottom: 40,
//                                     left: -400, color: 'black',
//                                     whiteSpace:'nowrap'
//                                 }}>
//                                     <div className='etapa-tag-container' style={{ position: 'relative' }}>


//                                         <div style={{
//                                             position: 'absolute',
//                                             bottom: -11,
//                                             left: 400
//                                         }} className='triangle-down'>

//                                         </div>

//                                             <span>    
//                                                 {this.state.valoareLog.map((v, idxLog)=>{
//                                                     return(
//                                                         <div key={`log${idxLog}`} style={{ width: 'fit-content', height: '100%', position: 'relative', cursor: 'pointer', display: 'block', textAlign:'left' }}>


//                                                                <div>
//                                                                    {/* {
//                                                                        c.poza &&
//                                                                        <div
//                                                                            className='pm-angajati-picture'
//                                                                            style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + c.poza}')`, width: 36, height: 36 }}>

//                                                                        </div>
//                                                                    } */}
//                                                                    {/* {!c.poza && */}


//                                                                         <Avatar  style={{ display: 'inline-flex',    width: 30,
//                                                                                                                        height: 30,
//                                                                                                                        fontSize: 16 }} className='pm-avatar'> {this.getLitereAvatar(v.nume_cine + ' ')} </Avatar>
//                                                                    {/* } */}
//                                                                <span style={{ fontSize:12}}  className='pm-task-change-user'> <span style={{fontWeight:800}}>{v.nume_cine}</span> {v.note} pe {this.u.ParseDataFromSql(v.cand)} la ora {this.u.ParseOraFromSql(v.cand)}</span>

//                                                                </div>

//                                                                </div>)
//                                                 })}

//                                                         </span>
//                                     </div>

//                                 </div>


//                     {ch.nr_modificari_noi > 0 && 
//                               <i onMouseEnter={()=>{this.showTag(c,ch)}} 
//                                 onMouseLeave={()=>{this.hideTag(c,ch)}}
//                               style={{verticalAlign: 'middle',
//                               cursor:'pointer',
//                               color:'red',
//                               marginRight: 10,
//                               fontSize:20}} className='material-icons'>error</i>
//                         }

//                                                 <input type='file' id={`fileCost1`}
//                                                     style={{ display: 'none' }}
//                                                     accept='.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf'
//                                                     onChange={() => { this.uploadCostDoc(`fileCost1`,  ch) }} />    

//                         <i 
//                          onClick={() => { this.addFileCost('fileCost1') }}
//                         style={{verticalAlign: 'middle',
//                                     cursor:'pointer',
//                                     marginRight: 10,
//                                     marginLeft:ch.nr_modificari_noi > 0 ? 0 : 30,
//                                     fontSize:20}} className='material-icons'>insert_drive_file</i>
//                         <i onClick={()=>{this.goToEdit(c, ch)}} style={{verticalAlign: 'middle',
//                                   cursor:'pointer',
//                                     fontSize:20}} className='material-icons'>edit</i>


//                     </td>

//                         </tr>
//                     )

//                 }else{

//                     return(
//                         <tr key={'ch'+idx2} style={{borderBottom:'1px solid gray', fontSize:12, lineHeight:'34px'}}>
//                             <td>{new Utils().ParseDataFromSql(ch.data_costului)}</td>
//                             <td> 
//                                 <select
//                                  style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
//                                  className='add-project-input'
//                                  type="text"
//                                  margin="normal"
//                                  name='id_task'
//                                  value={ch.id_task}
//                                  onChange={(ev) =>{this.changeCheltuiala(ev,ch, c)}}
//                                  placeholder='Task'
//                              >
//                                  <option value={'0'}>-</option>

//                                  {this.state.taskuri.map((l, idx) => {
//                                      return (
//                                          <option key={idx} value={l.id}>{l.titlu}</option>
//                                      )
//                                  })}

//                              </select>
//                              </td>
//                              <td>   
//                                  <input
//                                                         style={{ fontSize: 14, fontWeight: 400 }}
//                                                         id='titlu-task'
//                                                         type="text"
//                                                         className='hidden-input'
//                                                         margin="normal"
//                                                         name='nume'
//                                                         value={ch.nume || ''}
//                                                         onChange={(ev) =>{this.changeCheltuiala(ev,ch, c)}}
//                                                     />
//                                                     </td>

//                                                     <td style={{cursor:'pointer'}} onClick={()=>{this.setState({openBuget:true, cheltuialaSelectata:ch})}}>
//                             {ch.valoare_buget} lei
//                          </td>
//                                                     <td>
//                                                     <input
//                                                         style={{ fontSize: 14, fontWeight: 400, width: '50%'}}
//                                                         id='titlu-task'
//                                                         type="number"
//                                                         className='hidden-input'
//                                                         margin="normal"
//                                                         name='valoare'
//                                                         value={ch.valoare || ''}
//                                                         onChange={(ev) =>{this.changeCheltuiala(ev,ch, c)}}
//                                                     /> lei
//                                                     </td>
//                                                     <td>{ch.profit || 0} lei</td>

//                          <td>

//                                  <span style={{cursor:'pointer'}} onClick={()=>{this.goToFileCost(ch, c)}}>   {ch.document_nume.length > 10 ? ch.document_nume.substring(0,10) + '...' : ch.document_nume} </span>    

//                                         <i
//                     onClick={()=>{this.editCheltuiala(c, ch) }}
//                     style={{
//                         backgroundColor: 'rgb(24, 165, 58)',
//                         cursor: 'pointer',
//                         color: 'white',
//                         borderRadius: 20,
//                         padding: 5,
//                         verticalAlign: 'middle',
//                     }} className='material-icons'>check_circle_outline</i>

//                     </td> 

//                         </tr>
//                     )
//                 }

//             })}


//         </tbody>
//     </table>
// </Grid>
//     }